var _defs, _g, _defs2, _g2, _defs3, _g3, _defs4, _g4, _defs5, _g5, _defs6, _g6, _defs7, _g7, _defs8, _g8, _defs9, _g9, _defs0, _g0, _defs1, _g1, _defs10, _g10, _defs11, _g11, _defs12, _g12, _defs13, _g13, _defs14, _g14, _defs15, _g15, _defs16, _g16, _defs17, _g17, _defs18, _g18, _defs19, _g19, _defs20, _g20, _defs21, _g21, _defs22, _g22, _defs23, _g23, _defs24, _g24, _defs25, _g25, _defs26, _g26, _defs27, _g27, _defs28, _g28, _defs29, _g29, _defs30, _g30, _defs31, _g31, _defs32, _g32, _defs33, _g33, _defs34, _g34, _defs35, _g35, _defs36, _g36, _defs37, _g37, _defs38, _g38, _defs39, _g39, _defs40, _g40, _defs41, _g41, _defs42, _g42, _defs43, _g43, _defs44, _g44, _defs45, _g45, _defs46, _g46, _defs47, _g47, _defs48, _g48, _defs49, _g49, _defs50, _g50, _g51, _defs51, _style, _g52, _defs52, _defs53, _g53;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpritecssD6F47756(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 478,
    height: 396,
    viewBox: "0 0 478 396",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_0",
    x: 156,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "aaa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#aaa)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 34c-.8 0-2 .6-2.8 1.3.9-1 2.1-2.6 2.1-3.6a3 3 0 0 0-3-3.1 3 3 0 0 0-3 3c0 1.1 1.2 2.8 2 3.8-.8-.8-2-1.5-2.7-1.5a3 3 0 0 0-3 3 3 3 0 0 0 3 3.1c1 0 2.3-1 3.3-1.9a27 27 0 0 1-.7 2l-1.2 2h4.5l-1.2-2-.7-2c1 .9 2.4 2 3.4 2a3 3 0 0 0 2.7-1.6 3 3 0 0 0 0-3 3 3 0 0 0-2.7-1.6zm-1.1-9.5-.7-3.5h-4l-.7 3.5h-4l4.3-19h5l4.3 19h-4.2zm-2.6-15-1.6 8.2h3l-1.4-8.1z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_1",
    y: 111,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "aba"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#aba)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 34c-.8 0-2 .6-2.8 1.3.9-1 2.1-2.6 2.1-3.6a3 3 0 0 0-3-3.1 3 3 0 0 0-3 3c0 1.1 1.2 2.8 2 3.8-.8-.8-2-1.5-2.7-1.5a3 3 0 0 0-3 3 3 3 0 0 0 3 3.1c1 0 2.3-1 3.3-1.9a27 27 0 0 1-.7 2l-1.2 2h4.5l-1.2-2-.7-2c1 .9 2.4 2 3.4 2a3 3 0 0 0 2.7-1.6 3 3 0 0 0 0-3 3 3 0 0 0-2.7-1.6zm1.7-23c0 .6 0 1.1-.2 1.7l-.7 1.5-1 1.4-1 1.3-3.7 4h6.4v3.6H5.7v-3.7l6-6.5c.4-.5.8-1 1.1-1.7.3-.5.4-1 .4-1.6 0-.4 0-1-.4-1.3-.2-.4-.7-.7-1.2-.6-.6 0-1 .2-1.4.6-.4.5-.6 1.1-.6 1.8L5.4 11c.1-1.6.8-3.1 2-4.2a7.1 7.1 0 0 1 6.7-1c.8.2 1.4.6 2 1a6 6 0 0 1 1.6 4z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_10",
    x: 46,
    y: 111,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "aca"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#aca)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 34c-.8 0-2 .6-2.8 1.3.9-1 2.1-2.6 2.1-3.6a3 3 0 0 0-3-3.1 3 3 0 0 0-3 3c0 1.1 1.2 2.8 2 3.8-.8-.8-2-1.5-2.7-1.5a3 3 0 0 0-3 3 3 3 0 0 0 3 3.1c1 0 2.3-1 3.3-1.9a27 27 0 0 1-.7 2l-1.2 2h4.5l-1.2-2-.7-2c1 .9 2.4 2 3.4 2a3 3 0 0 0 2.7-1.6 3 3 0 0 0 0-3 3 3 0 0 0-2.7-1.6zm.2-11.2a6.1 6.1 0 0 1-4.8 1.7c-1.4 0-2.7-.4-3.8-1.1a5 5 0 0 1-2-3L9.3 19c.1.4.3.8.6 1.1.2.3.6.5 1 .5.6 0 1.2-.2 1.4-.7.2-.6.3-1.3.3-2V5.4h5v12.7c0 1.7-.5 3.3-1.6 4.7z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_11",
    x: 92,
    y: 111,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "ada"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ada)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 34c-.8 0-2 .6-2.8 1.3.9-1 2.1-2.6 2.1-3.6a3 3 0 0 0-3-3.1 3 3 0 0 0-3 3c0 1.1 1.2 2.8 2 3.8-.8-.8-2-1.5-2.7-1.5a3 3 0 0 0-3 3 3 3 0 0 0 3 3.1c1 0 2.3-1 3.3-1.9a27 27 0 0 1-.7 2l-1.2 2h4.5l-1.2-2-.7-2c1 .9 2.4 2 3.4 2a3 3 0 0 0 2.7-1.6 3 3 0 0 0 0-3 3 3 0 0 0-2.7-1.6zm1.3-12.5c.6-.9 1-1.9 1.3-3a14.7 14.7 0 0 0 0-7.6c-.2-1-.7-2-1.3-3A6.2 6.2 0 0 0 15 6.2a6 6 0 0 0-2.8-.7c-1 0-2 .3-2.9.7-.8.5-1.5 1.1-2 1.9a9 9 0 0 0-1.4 3 14.7 14.7 0 0 0 0 7.6c.3 1 .7 2 1.3 3 .6.7 1.3 1.4 2.2 1.8.5.3 1.1.5 1.8.6l.2.4c.5.7 1.1 1.3 1.8 1.8a5.6 5.6 0 0 0 4.1 1V24a2 2 0 0 1-1.6 0l-.8-.5.1-.1c.9-.5 1.6-1.1 2.2-1.9zm-2.4-4.4a7 7 0 0 1-.6 1.7c-.2.5-.4.9-.8 1.2-.3.3-.7.4-1.2.4-.4 0-.9-.1-1.2-.4-.4-.3-.6-.7-.8-1.2-.3-.5-.4-1-.5-1.7a12.8 12.8 0 0 1 .5-6c.2-.5.4-.8.8-1.2a2 2 0 0 1 1.2-.4c.4 0 .9.2 1.2.4.4.4.6.7.8 1.2.3.5.5 1.1.6 1.7a12.5 12.5 0 0 1 0 4.3z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_12",
    x: 138,
    y: 111,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "aea"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#aea)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 34c-.8 0-2 .6-2.8 1.3.9-1 2.1-2.6 2.1-3.6a3 3 0 0 0-3-3.1 3 3 0 0 0-3 3c0 1.1 1.2 2.8 2 3.8-.8-.8-2-1.5-2.7-1.5a3 3 0 0 0-3 3 3 3 0 0 0 3 3.1c1 0 2.3-1 3.3-1.9a27 27 0 0 1-.7 2l-1.2 2h4.5l-1.2-2-.7-2c1 .9 2.4 2 3.4 2a3 3 0 0 0 2.7-1.6 3 3 0 0 0 0-3 3 3 0 0 0-2.7-1.6zM14 24.5l-4.1-8.8h-.1v8.8H5.4v-19h4.4v7.9l4-8h5l-5 8.8L19 24.5z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_13",
    x: 202,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "afa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#afa)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bc3030"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2 43.6 6.8 36l5.4-7.5 5.4 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.8 24.5-.7-3.5h-4l-.7 3.5h-4l4.3-19h5l4.3 19h-4.2zm-2.6-15-1.6 8.2h3l-1.4-8.1z",
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_14",
    x: 202,
    y: 57,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "aga"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#aga)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bc3030"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9 43.6 5.4 36l5.5-7.5 5.4 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 11c0 .6 0 1.1-.2 1.7l-.7 1.5-1 1.4-1 1.3-3.7 4h6.4v3.6H5.7v-3.7l6-6.5c.4-.5.8-1 1.1-1.7.3-.5.4-1 .4-1.6 0-.4 0-1-.4-1.3-.2-.4-.7-.7-1.2-.6-.6 0-1 .2-1.4.6-.4.5-.6 1.1-.6 1.8L5.4 11c.1-1.6.8-3.1 2-4.2a7.1 7.1 0 0 1 6.7-1c.8.2 1.4.6 2 1a6 6 0 0 1 1.6 4z",
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_15",
    y: 168,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "aha"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#aha)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bc3030"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.852 43.556 5.43 36.069l5.423-7.486 5.434 7.486z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.641 18.755a5.929 5.929 0 0 1-.476 2.457 5.32 5.32 0 0 1-1.277 1.802 5.46 5.46 0 0 1-1.905 1.11 7.2 7.2 0 0 1-2.38.373 6.915 6.915 0 0 1-4.024-1.148 5.595 5.595 0 0 1-2.15-3.506l3.809-.928a3.13 3.13 0 0 0 .754 1.468c.382.39.925.6 1.484.57.31.007.616-.064.888-.205a2.03 2.03 0 0 0 .635-.54c.17-.232.299-.489.381-.761.08-.283.12-.574.12-.867a2.113 2.113 0 0 0-.715-1.757 2.967 2.967 0 0 0-1.905-.563H9.873v-3.042h1.11a2.178 2.178 0 0 0 1.659-.609 2.361 2.361 0 0 0 .58-1.688 2.368 2.368 0 0 0-.421-1.324 1.491 1.491 0 0 0-1.333-.616 1.524 1.524 0 0 0-1.215.487 3.228 3.228 0 0 0-.65 1.24l-3.73-.898a6.18 6.18 0 0 1 .936-2.015c.377-.523.84-.983 1.373-1.362a5.666 5.666 0 0 1 1.69-.76 7.324 7.324 0 0 1 1.857-.229c.693 0 1.382.105 2.04.312.645.2 1.246.515 1.77.928.523.418.95.936 1.253 1.522.324.682.484 1.425.469 2.175a4.851 4.851 0 0 1-.723 2.67 3.412 3.412 0 0 1-1.896 1.52v.077c.9.232 1.68.773 2.19 1.52a4.43 4.43 0 0 1 .81 2.587z",
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_16",
    x: 46,
    y: 168,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "aia"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#aia)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bc3030"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.852 43.556 5.43 36.069l5.423-7.486 5.434 7.486z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.783 5.444V17.13h1.865v3.56h-1.865v3.81h-3.677v-3.811H5.429V17.03l5.33-11.586h5.024zm-3.601 4.208h-.053l-3.13 7.477h3.183V9.652z",
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_17",
    x: 92,
    y: 168,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "aja"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#aja)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc3030",
    d: "M10.852 43.556 5.43 36.069l5.423-7.486 5.434 7.486zm6.788-25.642a7.81 7.81 0 0 1-.486 2.888 5.74 5.74 0 0 1-1.321 2.05 5.232 5.232 0 0 1-1.97 1.235 6.962 6.962 0 0 1-2.434.412 6.533 6.533 0 0 1-3.884-1.181c-1.147-.911-1.9-2.186-2.116-3.583L9.207 18.6c.124.573.384 1.113.763 1.577.326.43.858.678 1.419.663.632.034 1.228-.281 1.524-.807.359-.605.536-1.29.511-1.982a2.58 2.58 0 0 0-.81-2.134 3.127 3.127 0 0 0-2.028-.686 9.01 9.01 0 0 0-1.97.251c-.656.139-1.3.327-1.922.564L7.05 5.444h9.902v3.659h-6.204l-.138 3.201c.243-.097.496-.168.754-.213.24-.048.485-.073.73-.077a6.193 6.193 0 0 1 2.36.42 4.709 4.709 0 0 1 1.735 1.189 5.246 5.246 0 0 1 1.079 1.836c.263.795.389 1.623.373 2.455z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_18",
    x: 138,
    y: 168,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "aka"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#aka)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc3030",
    d: "M10.852 43.556 5.43 36.069l5.423-7.486 5.434 7.486zm4.53-38.112-3.607 6.38c.136-.07.283-.116.434-.137.188-.015.377-.015.565 0 .743-.02 1.48.142 2.143.473a4.377 4.377 0 0 1 1.548 1.29 5.58 5.58 0 0 1 .875 1.915 9.24 9.24 0 0 1 .301 2.412 8.363 8.363 0 0 1-.448 2.861 5.867 5.867 0 0 1-1.262 2.106 5.42 5.42 0 0 1-1.919 1.305 6.448 6.448 0 0 1-2.422.45 6.856 6.856 0 0 1-2.477-.434 5.228 5.228 0 0 1-1.942-1.29c-.565-.596-1-1.3-1.277-2.068a7.987 7.987 0 0 1-.464-2.824 10.064 10.064 0 0 1 .449-3.052 15.86 15.86 0 0 1 1.13-2.671l3.552-6.716h4.82zm-3.823 9.219a1.752 1.752 0 0 0-1.455.87 3.858 3.858 0 0 0-.588 2.213 3.896 3.896 0 0 0 .588 2.198c.293.536.86.87 1.478.87.617 0 1.185-.334 1.478-.87.386-.668.569-1.43.526-2.198a4.158 4.158 0 0 0-.534-2.228 1.684 1.684 0 0 0-1.493-.855z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_19",
    x: 184,
    y: 168,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "ala"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ala)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc3030",
    d: "M10.852 43.556 5.43 36.069l5.423-7.486 5.434 7.486zm.692-19.056H6.42l6.125-15.244H5.429V5.444h12.214v3.232z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_2",
    x: 248,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "ama"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ama)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 34c-.8 0-2 .6-2.8 1.3.9-1 2.1-2.6 2.1-3.6a3 3 0 0 0-3-3.1 3 3 0 0 0-3 3c0 1.1 1.2 2.8 2 3.8-.8-.8-2-1.5-2.7-1.5a3 3 0 0 0-3 3 3 3 0 0 0 3 3.1c1 0 2.3-1 3.3-1.9a27 27 0 0 1-.7 2l-1.2 2h4.5l-1.2-2-.7-2c1 .9 2.4 2 3.4 2a3 3 0 0 0 2.7-1.6 3 3 0 0 0 0-3 3 3 0 0 0-2.7-1.6zm1.7-15.2a6 6 0 0 1-.4 2.4 5.3 5.3 0 0 1-3.2 3l-2.4.3a7 7 0 0 1-4-1.2c-1.2-.8-2-2-2.2-3.5l3.8-.9c.2.6.4 1 .8 1.5.4.4 1 .6 1.5.6a1.8 1.8 0 0 0 1.5-.8l.4-.8.1-.8c0-.7-.2-1.3-.7-1.8a3 3 0 0 0-2-.5h-1v-3H11c.6 0 1.2-.3 1.6-.7.5-.5.7-1 .6-1.7 0-.5-.1-1-.4-1.3-.3-.4-.8-.7-1.3-.6-.5 0-1 .1-1.2.5-.4.3-.6.8-.7 1.2l-3.7-.9c.2-.7.5-1.4 1-2 .3-.5.7-1 1.3-1.4a7.3 7.3 0 0 1 5.6-.7l1.7 1c.6.4 1 1 1.3 1.5.3.7.5 1.4.5 2.2 0 1-.3 1.8-.8 2.7-.4.7-1 1.2-1.9 1.5 1 .3 1.7.8 2.2 1.6.6.7.8 1.6.8 2.6z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_20",
    x: 248,
    y: 57,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "ana"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ana)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc3030",
    d: "M10.852 43.556 5.43 36.069l5.423-7.486 5.434 7.486zm6.79-24.582a5.488 5.488 0 0 1-.43 2.195 5.15 5.15 0 0 1-1.234 1.745 5.738 5.738 0 0 1-1.93 1.159 7.328 7.328 0 0 1-2.563.426 7.192 7.192 0 0 1-2.532-.426 5.703 5.703 0 0 1-1.898-1.159A5.07 5.07 0 0 1 5.85 21.17a5.614 5.614 0 0 1-.421-2.195 4.997 4.997 0 0 1 .25-1.661 4.65 4.65 0 0 1 .664-1.303c.253-.362.57-.677.937-.93.335-.236.7-.428 1.086-.572v-.053a3.887 3.887 0 0 1-1.906-1.524 4.44 4.44 0 0 1-.664-2.492 4.95 4.95 0 0 1 .36-1.86c.23-.6.583-1.147 1.038-1.608a5.212 5.212 0 0 1 1.774-1.12 6.841 6.841 0 0 1 2.508-.404 6.872 6.872 0 0 1 2.508.427c.674.244 1.29.617 1.813 1.097.477.454.852.999 1.102 1.6.244.591.369 1.223.367 1.86.03.875-.198 1.74-.656 2.492a3.948 3.948 0 0 1-1.883 1.524v.054a4.82 4.82 0 0 1 1.086.579c.36.26.676.574.937.93.287.394.506.832.649 1.295.17.54.252 1.104.242 1.67zm-4.266-.228a3.172 3.172 0 0 0-.524-1.868c-.3-.46-.82-.74-1.379-.74s-1.08.28-1.379.74a3.171 3.171 0 0 0-.523 1.898 3.223 3.223 0 0 0 .5 1.867 1.7 1.7 0 0 0 1.41.742 1.7 1.7 0 0 0 1.41-.742 3.34 3.34 0 0 0 .485-1.897zm-.156-7.964a2.916 2.916 0 0 0-.446-1.67 1.472 1.472 0 0 0-1.297-.655 1.432 1.432 0 0 0-1.29.656 2.99 2.99 0 0 0-.437 1.669c-.01.581.153 1.153.47 1.646.247.451.732.73 1.257.724a1.437 1.437 0 0 0 1.282-.724 2.992 2.992 0 0 0 .46-1.646z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_21",
    x: 248,
    y: 114,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "aoa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#aoa)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc3030",
    d: "M10.852 43.556 5.43 36.069l5.423-7.486 5.434 7.486zm-.491-25.524a4.62 4.62 0 0 1-2.156-.474 4.572 4.572 0 0 1-1.546-1.28 5.446 5.446 0 0 1-.92-1.919 9.007 9.007 0 0 1-.309-2.376c-.02-.966.14-1.927.472-2.834a5.75 5.75 0 0 1 1.306-2.057 5.306 5.306 0 0 1 1.955-1.227 6.773 6.773 0 0 1 2.404-.42 6.45 6.45 0 0 1 2.404.42 5.408 5.408 0 0 1 1.932 1.265c.561.59.995 1.291 1.275 2.058.323.901.48 1.853.464 2.81a10.065 10.065 0 0 1-.449 3.107c-.3.91-.678 1.794-1.128 2.64L12.518 24.5H7.702l3.656-6.623a1.302 1.302 0 0 1-.433.132 2.954 2.954 0 0 1-.564.023zm-.865-5.956c-.018.763.18 1.514.571 2.167.312.523.878.84 1.484.83a1.745 1.745 0 0 0 1.484-.846c.4-.643.594-1.393.557-2.15a3.725 3.725 0 0 0-.58-2.175 1.722 1.722 0 0 0-1.468-.83 1.698 1.698 0 0 0-1.477.792 3.78 3.78 0 0 0-.571 2.212z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_22",
    y: 225,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "apa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#apa)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bc3030"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.21 43.556-5.424-7.487 5.423-7.486 5.434 7.486z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.245 11.722a10.74 10.74 0 0 0-.919-3.086 6.2 6.2 0 0 0-1.86-2.281 4.949 4.949 0 0 0-3.089-.905 4.926 4.926 0 0 0-3.088.905 6.215 6.215 0 0 0-1.868 2.28 10.74 10.74 0 0 0-.904 3.087 23.73 23.73 0 0 0-.231 3.262c.006 1.081.086 2.16.24 3.231.142 1.07.446 2.113.902 3.095a6.215 6.215 0 0 0 1.869 2.28 4.972 4.972 0 0 0 3.088.905 4.996 4.996 0 0 0 3.088-.905 6.2 6.2 0 0 0 1.861-2.28 10.73 10.73 0 0 0 .919-3.095c.33-2.142.33-4.32 0-6.462l-.008-.03zm-4.015 5.2a11.19 11.19 0 0 1-.278 1.901c-.111.51-.307.998-.579 1.445a1.12 1.12 0 0 1-.996.585 1.139 1.139 0 0 1-.996-.547 4.732 4.732 0 0 1-.579-1.445 10.649 10.649 0 0 1-.27-1.9 29.478 29.478 0 0 1-.07-1.97l.07-1.938a10.96 10.96 0 0 1 .27-1.908 4.753 4.753 0 0 1 .58-1.483c.197-.36.58-.585.995-.586s.8.223.996.586c.273.452.469.945.58 1.46a11.81 11.81 0 0 1 .277 1.908l.062 1.939-.062 1.954zM5.429 9.268 7.3 12.601l2.803-2.153V24.5h4.147V5.444h-3.696z",
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_23",
    x: 46,
    y: 225,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "aqa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#aqa)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bc3030"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M10.852 43.556 5.43 36.069l5.423-7.486 5.434 7.486z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1 22.773c-1.164 1.19-2.938 1.829-4.759 1.714-1.4.033-2.768-.358-3.857-1.103-1.063-.757-1.788-1.799-2.055-2.952l3.96-1.5c.11.398.31.772.591 1.104.244.301.648.482 1.08.484.585.047 1.133-.247 1.332-.714a4.85 4.85 0 0 0 .32-1.968V5.444h4.917V18.14c.11 1.645-.429 3.275-1.53 4.634z"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_24",
    x: 92,
    y: 225,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "ara"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ara)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc3030",
    d: "m12.21 43.556-5.424-7.487 5.423-7.486 5.434 7.486zm4.97-22.05a9.202 9.202 0 0 0 1.344-2.961c.327-1.254.487-2.546.475-3.842a14.355 14.355 0 0 0-.475-3.817 9.097 9.097 0 0 0-1.345-2.93 6.197 6.197 0 0 0-2.142-1.88 6.037 6.037 0 0 0-2.826-.63 6.158 6.158 0 0 0-2.867.662 6.245 6.245 0 0 0-2.134 1.88 9.089 9.089 0 0 0-1.337 2.93 14.719 14.719 0 0 0-.443 3.785 14.719 14.719 0 0 0 .475 3.842 9.202 9.202 0 0 0 1.345 2.961 6.238 6.238 0 0 0 2.134 1.905 5.79 5.79 0 0 0 1.772.581l.265.412a7.32 7.32 0 0 0 1.804 1.824 5.63 5.63 0 0 0 2.175.904 5.2 5.2 0 0 0 1.932 0v-3.124a2.017 2.017 0 0 1-1.61 0 2.842 2.842 0 0 1-.854-.548l.145-.073a6.189 6.189 0 0 0 2.166-1.88zm-2.424-4.398a7.088 7.088 0 0 1-.527 1.731c-.185.438-.466.83-.822 1.149a1.81 1.81 0 0 1-1.193.429 1.894 1.894 0 0 1-1.217-.43 3.237 3.237 0 0 1-.822-1.148 6.447 6.447 0 0 1-.51-1.731 12.816 12.816 0 0 1-.164-2.16 12.49 12.49 0 0 1 .164-2.144c.088-.595.26-1.174.51-1.723a3.15 3.15 0 0 1 .822-1.14 1.92 1.92 0 0 1 1.217-.413c.435-.007.858.14 1.193.413.358.314.64.704.822 1.14.25.55.426 1.13.527 1.723.119.709.177 1.426.172 2.144a12.786 12.786 0 0 1-.205 2.16h.033z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_25",
    x: 138,
    y: 225,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "asa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#asa)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc3030",
    d: "m12.21 43.556-5.424-7.487 5.423-7.486 5.434 7.486zM13.97 24.5l-4.103-8.845h-.08V24.5H5.43V5.444h4.366v7.94h.08l3.992-7.94h4.854l-4.966 8.734L19 24.5z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_26",
    x: 184,
    y: 225,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "ata"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ata)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.578 28.583a3.434 3.434 0 0 0-3.364 2.752 3.433 3.433 0 0 0-3.7-2.698 3.438 3.438 0 0 0-3.085 3.388c0 2.703 6.785 10.17 6.785 10.17S19 34.727 19 32.024a3.437 3.437 0 0 0-.999-2.433 3.417 3.417 0 0 0-2.423-1.009zM14.83 24.5l-.753-3.47H10.14l-.754 3.47H5.429l4.29-19.056h5.014L19 24.5h-4.17zM12.215 9.589h-.105l-1.51 8.099h3.016l-1.403-8.099z",
    fill: "#bc3030",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_27",
    x: 230,
    y: 225,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "aua"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#aua)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.578 28.583a3.434 3.434 0 0 0-3.364 2.752 3.433 3.433 0 0 0-3.7-2.698 3.438 3.438 0 0 0-3.085 3.388c0 2.703 6.785 10.17 6.785 10.17S19 34.727 19 32.024a3.437 3.437 0 0 0-.999-2.433 3.417 3.417 0 0 0-2.423-1.009zm2.064-17.596a5.711 5.711 0 0 1-.247 1.715 7.775 7.775 0 0 1-.674 1.524c-.28.475-.596.931-.947 1.364-.362.442-.724.862-1.095 1.265l-3.695 4.025h6.411v3.62H5.667v-3.735l6.017-6.5a7.323 7.323 0 0 0 1.152-1.624c.263-.496.404-1.04.411-1.593a2.368 2.368 0 0 0-.403-1.395 1.456 1.456 0 0 0-1.267-.58 1.695 1.695 0 0 0-1.35.618 3.16 3.16 0 0 0-.601 1.799l-4.197-.366c.08-1.608.815-3.128 2.057-4.253 1.168-.948 2.678-1.456 4.23-1.425a7.129 7.129 0 0 1 2.47.396 5.446 5.446 0 0 1 1.851 1.128 4.8 4.8 0 0 1 1.186 1.738 6 6 0 0 1 .42 2.279z",
    fill: "#bc3030",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_28",
    x: 294,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "ava"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ava)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.578 28.583a3.434 3.434 0 0 0-3.364 2.752 3.433 3.433 0 0 0-3.7-2.698 3.438 3.438 0 0 0-3.085 3.388c0 2.703 6.785 10.17 6.785 10.17S19 34.727 19 32.024a3.437 3.437 0 0 0-.999-2.433 3.417 3.417 0 0 0-2.423-1.009zm2.063-9.828a5.929 5.929 0 0 1-.476 2.457 5.32 5.32 0 0 1-1.277 1.802 5.46 5.46 0 0 1-1.905 1.11 7.2 7.2 0 0 1-2.38.373 6.915 6.915 0 0 1-4.024-1.148 5.595 5.595 0 0 1-2.15-3.506l3.809-.928a3.13 3.13 0 0 0 .754 1.468c.382.39.925.6 1.484.57.31.007.616-.064.888-.205a2.03 2.03 0 0 0 .635-.54c.17-.232.299-.489.381-.761.08-.283.12-.574.12-.867a2.113 2.113 0 0 0-.715-1.757 2.967 2.967 0 0 0-1.905-.563H9.873v-3.042h1.11a2.178 2.178 0 0 0 1.659-.609 2.361 2.361 0 0 0 .58-1.688 2.368 2.368 0 0 0-.421-1.324 1.491 1.491 0 0 0-1.333-.616 1.524 1.524 0 0 0-1.215.487 3.228 3.228 0 0 0-.65 1.24l-3.73-.898a6.18 6.18 0 0 1 .936-2.015c.377-.523.84-.983 1.373-1.362a5.666 5.666 0 0 1 1.69-.76 7.324 7.324 0 0 1 1.857-.229c.693 0 1.382.105 2.04.312.645.2 1.246.515 1.77.928.523.418.95.936 1.253 1.522.324.682.484 1.425.469 2.175a4.851 4.851 0 0 1-.723 2.67 3.412 3.412 0 0 1-1.896 1.52v.077c.9.232 1.68.773 2.19 1.52a4.43 4.43 0 0 1 .81 2.587z",
    fill: "#bc3030",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_29",
    x: 294,
    y: 57,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "awa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#awa)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.578 28.583a3.434 3.434 0 0 0-3.364 2.752 3.433 3.433 0 0 0-3.7-2.698 3.438 3.438 0 0 0-3.085 3.388c0 2.703 6.785 10.17 6.785 10.17S19 34.727 19 32.024a3.437 3.437 0 0 0-.999-2.433 3.417 3.417 0 0 0-2.423-1.009zm.205-7.894V24.5h-3.677v-3.811H5.429V17.03l5.33-11.586h5.024V17.13h1.865v3.56h-1.865zM12.182 9.652h-.053l-3.13 7.477h3.183V9.652z",
    fill: "#bc3030",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_3",
    x: 294,
    y: 114,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "axa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#axa)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 34c-.8 0-2 .6-2.8 1.3.9-1 2.1-2.6 2.1-3.6a3 3 0 0 0-3-3.1 3 3 0 0 0-3 3c0 1.1 1.2 2.8 2 3.8-.8-.8-2-1.5-2.7-1.5a3 3 0 0 0-3 3 3 3 0 0 0 3 3.1c1 0 2.3-1 3.3-1.9a27 27 0 0 1-.7 2l-1.2 2h4.5l-1.2-2-.7-2c1 .9 2.4 2 3.4 2a3 3 0 0 0 2.7-1.6 3 3 0 0 0 0-3 3 3 0 0 0-2.7-1.6zm-.1-28.6v11.7h1.8v3.6h-1.8v3.8H12v-3.8H5.4V17l5.4-11.6h5zm-3.6 4.3L9 17h3.2V9.7z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_30",
    x: 294,
    y: 171,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-17.1%",
    y: "-11.2%",
    width: "134.2%",
    height: "126.5%",
    id: "aya"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "ayb",
    width: 38,
    height: 49,
    rx: 4
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#aya)",
    href: "#ayb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    href: "#ayb"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#bc3030"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.578 31.583a3.434 3.434 0 0 0-3.364 2.752 3.433 3.433 0 0 0-3.7-2.698 3.438 3.438 0 0 0-3.085 3.388c0 2.703 6.785 10.17 6.785 10.17S23 37.727 23 35.024a3.437 3.437 0 0 0-.999-2.433 3.417 3.417 0 0 0-2.423-1.009z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.64 20.914a7.81 7.81 0 0 1-.486 2.888 5.74 5.74 0 0 1-1.321 2.05 5.232 5.232 0 0 1-1.97 1.235 6.962 6.962 0 0 1-2.434.412 6.533 6.533 0 0 1-3.884-1.181c-1.147-.911-1.9-2.186-2.116-3.583l3.778-1.135c.124.573.384 1.113.763 1.577.326.43.858.678 1.419.663.632.034 1.228-.281 1.524-.807.359-.605.536-1.29.511-1.982a2.58 2.58 0 0 0-.81-2.134 3.127 3.127 0 0 0-2.028-.686 9.01 9.01 0 0 0-1.97.251c-.656.139-1.3.327-1.922.564l.356-10.602h9.902v3.659h-6.204l-.138 3.201c.243-.097.496-.168.754-.213.24-.048.485-.073.73-.077a6.193 6.193 0 0 1 2.36.42 4.709 4.709 0 0 1 1.735 1.189 5.246 5.246 0 0 1 1.079 1.836c.263.795.389 1.623.373 2.455z"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_31",
    y: 282,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "aza"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#aza)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bc3030"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.578 28.583a3.434 3.434 0 0 0-3.364 2.752 3.433 3.433 0 0 0-3.7-2.698 3.438 3.438 0 0 0-3.085 3.388c0 2.703 6.785 10.17 6.785 10.17S19 34.727 19 32.024a3.437 3.437 0 0 0-.999-2.433 3.417 3.417 0 0 0-2.423-1.009z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.382 5.444-3.607 6.38c.136-.07.283-.116.434-.137.188-.015.377-.015.565 0 .743-.02 1.48.142 2.143.473a4.377 4.377 0 0 1 1.548 1.29 5.58 5.58 0 0 1 .875 1.915 9.24 9.24 0 0 1 .301 2.412 8.363 8.363 0 0 1-.448 2.861 5.867 5.867 0 0 1-1.262 2.106 5.42 5.42 0 0 1-1.919 1.305 6.448 6.448 0 0 1-2.422.45 6.856 6.856 0 0 1-2.477-.434 5.228 5.228 0 0 1-1.942-1.29c-.565-.596-1-1.3-1.277-2.068a7.987 7.987 0 0 1-.464-2.824 10.064 10.064 0 0 1 .449-3.052 15.86 15.86 0 0 1 1.13-2.671l3.552-6.716h4.82zm-3.823 9.219a1.752 1.752 0 0 0-1.455.87 3.858 3.858 0 0 0-.588 2.213 3.896 3.896 0 0 0 .588 2.198c.293.536.86.87 1.478.87.617 0 1.185-.334 1.478-.87.386-.668.569-1.43.526-2.198a4.158 4.158 0 0 0-.534-2.228 1.684 1.684 0 0 0-1.493-.855z"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_32",
    x: 46,
    y: 282,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "baa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#baa)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bc3030"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.578 28.583a3.434 3.434 0 0 0-3.364 2.752 3.433 3.433 0 0 0-3.7-2.698 3.438 3.438 0 0 0-3.085 3.388c0 2.703 6.785 10.17 6.785 10.17S19 34.727 19 32.024a3.437 3.437 0 0 0-.999-2.433 3.417 3.417 0 0 0-2.423-1.009z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.544 24.5H6.42l6.125-15.244H5.429V5.444h12.214v3.232z"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_33",
    x: 92,
    y: 282,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "bba"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bba)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bc3030"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.578 28.583a3.434 3.434 0 0 0-3.364 2.752 3.433 3.433 0 0 0-3.7-2.698 3.438 3.438 0 0 0-3.085 3.388c0 2.703 6.785 10.17 6.785 10.17S19 34.727 19 32.024a3.437 3.437 0 0 0-.999-2.433 3.417 3.417 0 0 0-2.423-1.009z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.642 18.974a5.488 5.488 0 0 1-.43 2.195 5.15 5.15 0 0 1-1.234 1.745 5.738 5.738 0 0 1-1.93 1.159 7.328 7.328 0 0 1-2.563.426 7.192 7.192 0 0 1-2.532-.426 5.703 5.703 0 0 1-1.898-1.159A5.07 5.07 0 0 1 5.85 21.17a5.614 5.614 0 0 1-.421-2.195 4.997 4.997 0 0 1 .25-1.661 4.65 4.65 0 0 1 .664-1.303c.253-.362.57-.677.937-.93.335-.236.7-.428 1.086-.572v-.053a3.887 3.887 0 0 1-1.906-1.524 4.44 4.44 0 0 1-.664-2.492 4.95 4.95 0 0 1 .36-1.86c.23-.6.583-1.147 1.038-1.608a5.212 5.212 0 0 1 1.774-1.12 6.841 6.841 0 0 1 2.508-.404 6.872 6.872 0 0 1 2.508.427c.674.244 1.29.617 1.813 1.097.477.454.852.999 1.102 1.6.244.591.369 1.223.367 1.86.03.875-.198 1.74-.656 2.492a3.948 3.948 0 0 1-1.883 1.524v.054a4.82 4.82 0 0 1 1.086.579c.36.26.676.574.937.93.287.394.506.832.649 1.295.17.54.252 1.104.242 1.67zm-4.266-.228a3.172 3.172 0 0 0-.524-1.868c-.3-.46-.82-.74-1.379-.74s-1.08.28-1.379.74a3.171 3.171 0 0 0-.523 1.898 3.223 3.223 0 0 0 .5 1.867 1.7 1.7 0 0 0 1.41.742 1.7 1.7 0 0 0 1.41-.742 3.34 3.34 0 0 0 .485-1.897zm-.156-7.964a2.916 2.916 0 0 0-.446-1.67 1.472 1.472 0 0 0-1.297-.655 1.432 1.432 0 0 0-1.29.656 2.99 2.99 0 0 0-.437 1.669c-.01.581.153 1.153.47 1.646.247.451.732.73 1.257.724a1.437 1.437 0 0 0 1.282-.724 2.992 2.992 0 0 0 .46-1.646z"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_34",
    x: 138,
    y: 282,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-17.1%",
    y: "-11.2%",
    width: "134.2%",
    height: "126.5%",
    id: "bca"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "bcb",
    width: 38,
    height: 49,
    rx: 4
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#bca)",
    href: "#bcb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    href: "#bcb"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#bc3030"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.578 31.583a3.434 3.434 0 0 0-3.364 2.752 3.433 3.433 0 0 0-3.7-2.698 3.438 3.438 0 0 0-3.085 3.388c0 2.703 6.785 10.17 6.785 10.17S23 37.727 23 35.024a3.437 3.437 0 0 0-.999-2.433 3.417 3.417 0 0 0-2.423-1.009z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.361 21.032a4.62 4.62 0 0 1-2.156-.474 4.572 4.572 0 0 1-1.546-1.28 5.446 5.446 0 0 1-.92-1.919 9.007 9.007 0 0 1-.309-2.376c-.02-.966.14-1.927.472-2.834a5.75 5.75 0 0 1 1.306-2.057 5.306 5.306 0 0 1 1.955-1.227 6.773 6.773 0 0 1 2.404-.42 6.45 6.45 0 0 1 2.404.42 5.408 5.408 0 0 1 1.932 1.265c.561.59.995 1.291 1.275 2.058.323.901.48 1.853.464 2.81a10.065 10.065 0 0 1-.449 3.107c-.3.91-.678 1.794-1.128 2.64L16.518 27.5h-4.816l3.656-6.623a1.302 1.302 0 0 1-.433.132 2.954 2.954 0 0 1-.564.023zm-.865-5.956c-.018.763.18 1.514.571 2.167.312.523.878.84 1.484.83a1.745 1.745 0 0 0 1.484-.846c.4-.643.594-1.393.557-2.15a3.725 3.725 0 0 0-.58-2.175 1.722 1.722 0 0 0-1.468-.83 1.698 1.698 0 0 0-1.477.792 3.78 3.78 0 0 0-.571 2.212z"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_35",
    x: 184,
    y: 282,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-17.1%",
    y: "-11.2%",
    width: "134.2%",
    height: "126.5%",
    id: "bda"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "bdb",
    width: 38,
    height: 49,
    rx: 4
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#bda)",
    href: "#bdb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    href: "#bdb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.578 31.583a3.434 3.434 0 0 0-3.364 2.752 3.433 3.433 0 0 0-3.7-2.698 3.438 3.438 0 0 0-3.085 3.388c0 2.703 6.785 10.17 6.785 10.17S23 37.727 23 35.024a3.437 3.437 0 0 0-.999-2.433 3.417 3.417 0 0 0-2.423-1.009zm12.667-16.861a10.74 10.74 0 0 0-.919-3.086 6.2 6.2 0 0 0-1.86-2.281 4.949 4.949 0 0 0-3.089-.905 4.926 4.926 0 0 0-3.088.905 6.215 6.215 0 0 0-1.868 2.28c-.455.98-.76 2.02-.904 3.087a23.73 23.73 0 0 0-.231 3.262c.006 1.081.086 2.16.24 3.231.142 1.07.446 2.113.902 3.095a6.215 6.215 0 0 0 1.869 2.28 4.972 4.972 0 0 0 3.088.905 4.996 4.996 0 0 0 3.088-.905 6.2 6.2 0 0 0 1.861-2.28 10.73 10.73 0 0 0 .919-3.095c.33-2.142.33-4.32 0-6.462l-.008-.03zm-4.015 5.2c-.038.64-.131 1.277-.278 1.901-.111.51-.307.998-.579 1.445a1.121 1.121 0 0 1-.996.585 1.139 1.139 0 0 1-.996-.547 4.732 4.732 0 0 1-.579-1.445 10.649 10.649 0 0 1-.27-1.9 29.478 29.478 0 0 1-.07-1.97c0-.623 0-1.246.07-1.938.034-.643.124-1.281.27-1.908a4.753 4.753 0 0 1 .58-1.483c.197-.36.58-.585.995-.586.417-.002.8.223.996.586.273.452.469.945.58 1.46.144.627.237 1.266.277 1.908.047.692.062 1.338.062 1.939 0 .6-.015 1.262-.062 1.954zM9.429 12.268l1.871 3.333 2.803-2.153V27.5h4.147V8.444h-3.696z",
    fill: "#bc3030",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_36",
    x: 230,
    y: 282,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "bea"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bea)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bc3030"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.578 28.583a3.434 3.434 0 0 0-3.364 2.752 3.433 3.433 0 0 0-3.7-2.698 3.438 3.438 0 0 0-3.085 3.388c0 2.703 6.785 10.17 6.785 10.17S19 34.727 19 32.024a3.437 3.437 0 0 0-.999-2.433 3.417 3.417 0 0 0-2.423-1.009z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1 22.773c-1.164 1.19-2.938 1.829-4.759 1.714-1.4.033-2.768-.358-3.857-1.103-1.063-.757-1.788-1.799-2.055-2.952l3.96-1.5c.11.398.31.772.591 1.104.244.301.648.482 1.08.484.585.047 1.133-.247 1.332-.714a4.85 4.85 0 0 0 .32-1.968V5.444h4.917V18.14c.11 1.645-.429 3.275-1.53 4.634z"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_37",
    x: 276,
    y: 282,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "bfa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bfa)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.578 28.583a3.434 3.434 0 0 0-3.364 2.752 3.433 3.433 0 0 0-3.7-2.698 3.438 3.438 0 0 0-3.085 3.388c0 2.703 6.785 10.17 6.785 10.17S19 34.727 19 32.024a3.437 3.437 0 0 0-.999-2.433 3.417 3.417 0 0 0-2.423-1.009zm1.602-7.077a9.202 9.202 0 0 0 1.344-2.961c.327-1.254.487-2.546.475-3.842a14.355 14.355 0 0 0-.475-3.817 9.097 9.097 0 0 0-1.345-2.93 6.197 6.197 0 0 0-2.142-1.88 6.037 6.037 0 0 0-2.826-.63 6.158 6.158 0 0 0-2.867.662 6.245 6.245 0 0 0-2.134 1.88 9.089 9.089 0 0 0-1.337 2.93 14.719 14.719 0 0 0-.443 3.785 14.719 14.719 0 0 0 .475 3.842 9.202 9.202 0 0 0 1.345 2.961 6.238 6.238 0 0 0 2.134 1.905 5.79 5.79 0 0 0 1.772.581l.265.412a7.32 7.32 0 0 0 1.804 1.824 5.63 5.63 0 0 0 2.175.904 5.2 5.2 0 0 0 1.932 0v-3.124a2.017 2.017 0 0 1-1.61 0 2.842 2.842 0 0 1-.854-.548l.145-.073a6.189 6.189 0 0 0 2.166-1.88zm-2.424-4.398a7.088 7.088 0 0 1-.527 1.731c-.185.438-.466.83-.822 1.149a1.81 1.81 0 0 1-1.193.429 1.894 1.894 0 0 1-1.217-.43 3.237 3.237 0 0 1-.822-1.148 6.447 6.447 0 0 1-.51-1.731 12.816 12.816 0 0 1-.164-2.16 12.49 12.49 0 0 1 .164-2.144c.088-.595.26-1.174.51-1.723a3.15 3.15 0 0 1 .822-1.14 1.92 1.92 0 0 1 1.217-.413c.435-.007.858.14 1.193.413.358.314.64.704.822 1.14.25.55.426 1.13.527 1.723.119.709.177 1.426.172 2.144a12.786 12.786 0 0 1-.205 2.16h.033z",
    fill: "#bc3030",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_38",
    x: 340,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "bga"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bga)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bc3030"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.578 28.583a3.434 3.434 0 0 0-3.364 2.752 3.433 3.433 0 0 0-3.7-2.698 3.438 3.438 0 0 0-3.085 3.388c0 2.703 6.785 10.17 6.785 10.17S19 34.727 19 32.024a3.437 3.437 0 0 0-.999-2.433 3.417 3.417 0 0 0-2.423-1.009z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.97 24.5-4.103-8.845h-.08V24.5H5.43V5.444h4.366v7.94h.08l3.992-7.94h4.854l-4.966 8.734L19 24.5z"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_39",
    x: 340,
    y: 57,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "bha"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bha)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.531 28.583S5.43 35.338 5.43 37.516c.048 1.57 1.43 2.807 3.087 2.764 1.09.02 2.111-.503 2.692-1.378l-.637 1.463-1.149 1.83h4.227s-.745-1.098-1.122-1.83c-.197-.365-.448-.978-.655-1.488.573.885 1.597 1.419 2.693 1.403a3.09 3.09 0 0 0 2.143-.777 2.777 2.777 0 0 0 .935-1.987c-.01-2.178-6.112-8.933-6.112-8.933zM14.83 24.5l-.753-3.47H10.14l-.754 3.47H5.429l4.29-19.056h5.014L19 24.5h-4.17zM12.215 9.589h-.105l-1.51 8.099h3.016l-1.403-8.099z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_4",
    x: 340,
    y: 114,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "bia"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bia)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 34c-.8 0-2 .6-2.8 1.3.9-1 2.1-2.6 2.1-3.6a3 3 0 0 0-3-3.1 3 3 0 0 0-3 3c0 1.1 1.2 2.8 2 3.8-.8-.8-2-1.5-2.7-1.5a3 3 0 0 0-3 3 3 3 0 0 0 3 3.1c1 0 2.3-1 3.3-1.9a27 27 0 0 1-.7 2l-1.2 2h4.5l-1.2-2-.7-2c1 .9 2.4 2 3.4 2a3 3 0 0 0 2.7-1.6 3 3 0 0 0 0-3 3 3 0 0 0-2.7-1.6zm1.7-16c0 .9-.1 1.9-.4 2.8-.3.8-.8 1.5-1.4 2-.5.6-1.2 1-2 1.3a7 7 0 0 1-2.4.4c-1.4 0-2.7-.4-3.9-1.2a5.7 5.7 0 0 1-2-3.6l3.7-1.1c.1.6.4 1.1.8 1.6.3.4.8.7 1.4.6.6 0 1.2-.2 1.5-.8.4-.6.5-1.3.5-2 .1-.7-.2-1.5-.8-2-.5-.5-1.3-.8-2-.8a13 13 0 0 0-3.9.8L7 5.4h10v3.7h-6.3v3.2l.7-.2h.7a4.7 4.7 0 0 1 4.1 1.6c.5.5.8 1 1 1.8.3.8.5 1.6.4 2.4z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_40",
    x: 340,
    y: 171,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-17.1%",
    y: "-11.2%",
    width: "134.2%",
    height: "126.5%",
    id: "bja"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "bjb",
    width: 38,
    height: 49,
    rx: 4
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#bja)",
    href: "#bjb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    href: "#bjb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.531 31.583S9.43 38.338 9.43 40.516c.048 1.57 1.43 2.807 3.087 2.764 1.09.02 2.111-.503 2.692-1.378l-.637 1.463-1.149 1.83h4.227s-.745-1.098-1.122-1.83c-.197-.365-.448-.978-.655-1.488.573.885 1.597 1.419 2.693 1.403a3.09 3.09 0 0 0 2.143-.777 2.777 2.777 0 0 0 .935-1.987c-.01-2.178-6.112-8.933-6.112-8.933zm6.111-17.596a5.711 5.711 0 0 1-.247 1.715 7.775 7.775 0 0 1-.674 1.524c-.28.475-.596.931-.947 1.364-.362.442-.724.862-1.095 1.265l-3.695 4.025h6.411v3.62H9.667v-3.735l6.017-6.5a7.323 7.323 0 0 0 1.152-1.624 3.49 3.49 0 0 0 .411-1.593 2.368 2.368 0 0 0-.403-1.395 1.456 1.456 0 0 0-1.267-.58 1.695 1.695 0 0 0-1.35.618 3.16 3.16 0 0 0-.601 1.799l-4.197-.366c.08-1.608.815-3.128 2.057-4.253 1.168-.948 2.678-1.456 4.23-1.425a7.13 7.13 0 0 1 2.47.396 5.446 5.446 0 0 1 1.851 1.128 4.8 4.8 0 0 1 1.186 1.738 6 6 0 0 1 .42 2.279z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_41",
    x: 340,
    y: 228,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "bka"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bka)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.531 28.583S5.43 35.338 5.43 37.516c.048 1.57 1.43 2.807 3.087 2.764 1.09.02 2.111-.503 2.692-1.378l-.637 1.463-1.149 1.83h4.227s-.745-1.098-1.122-1.83c-.197-.365-.448-.978-.655-1.488.573.885 1.597 1.419 2.693 1.403a3.09 3.09 0 0 0 2.143-.777 2.777 2.777 0 0 0 .935-1.987c-.01-2.178-6.112-8.933-6.112-8.933zm6.11-9.828a5.929 5.929 0 0 1-.476 2.457 5.32 5.32 0 0 1-1.277 1.802 5.46 5.46 0 0 1-1.905 1.11 7.2 7.2 0 0 1-2.38.373 6.915 6.915 0 0 1-4.024-1.148 5.595 5.595 0 0 1-2.15-3.506l3.809-.928a3.13 3.13 0 0 0 .754 1.468c.382.39.925.6 1.484.57a1.84 1.84 0 0 0 .888-.205 2.03 2.03 0 0 0 .635-.54c.17-.232.299-.489.381-.761.08-.283.12-.574.12-.867a2.113 2.113 0 0 0-.715-1.757 2.967 2.967 0 0 0-1.905-.563H9.873v-3.042h1.11a2.178 2.178 0 0 0 1.659-.609 2.361 2.361 0 0 0 .58-1.688 2.37 2.37 0 0 0-.421-1.324 1.491 1.491 0 0 0-1.333-.616 1.524 1.524 0 0 0-1.215.487 3.228 3.228 0 0 0-.65 1.24l-3.73-.898a6.18 6.18 0 0 1 .936-2.015 5.92 5.92 0 0 1 1.373-1.362 5.666 5.666 0 0 1 1.69-.76 7.324 7.324 0 0 1 1.857-.229c.693 0 1.382.105 2.04.312.645.2 1.246.515 1.77.928s.95.936 1.253 1.522a4.84 4.84 0 0 1 .469 2.175 4.851 4.851 0 0 1-.723 2.67 3.412 3.412 0 0 1-1.896 1.52v.077a3.79 3.79 0 0 1 2.19 1.52 4.43 4.43 0 0 1 .81 2.587z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_42",
    x: 386,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "bla"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bla)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.531 28.583S5.43 35.338 5.43 37.516c.048 1.57 1.43 2.807 3.087 2.764 1.09.02 2.111-.503 2.692-1.378l-.637 1.463-1.149 1.83h4.227s-.745-1.098-1.122-1.83c-.197-.365-.448-.978-.655-1.488.573.885 1.597 1.419 2.693 1.403a3.09 3.09 0 0 0 2.143-.777 2.777 2.777 0 0 0 .935-1.987c-.01-2.178-6.112-8.933-6.112-8.933zm4.252-7.894V24.5h-3.677v-3.811H5.429V17.03l5.33-11.586h5.024V17.13h1.865v3.56h-1.865zM12.182 9.652h-.053l-3.13 7.477h3.183V9.652z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_43",
    x: 386,
    y: 57,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "bma"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bma)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.531 28.583S5.43 35.338 5.43 37.516c.048 1.57 1.43 2.807 3.087 2.764 1.09.02 2.111-.503 2.692-1.378l-.637 1.463-1.149 1.83h4.227s-.745-1.098-1.122-1.83c-.197-.365-.448-.978-.655-1.488.573.885 1.597 1.419 2.693 1.403a3.09 3.09 0 0 0 2.143-.777 2.777 2.777 0 0 0 .935-1.987c-.01-2.178-6.112-8.933-6.112-8.933zm6.109-10.669a7.81 7.81 0 0 1-.486 2.888 5.74 5.74 0 0 1-1.321 2.05 5.232 5.232 0 0 1-1.97 1.235 6.96 6.96 0 0 1-2.434.412 6.533 6.533 0 0 1-3.884-1.181c-1.147-.911-1.9-2.186-2.116-3.583L9.207 18.6c.124.573.384 1.113.763 1.577.326.43.858.678 1.419.663.632.034 1.228-.281 1.524-.807.359-.605.536-1.29.511-1.982a2.58 2.58 0 0 0-.81-2.134 3.127 3.127 0 0 0-2.028-.686 9.01 9.01 0 0 0-1.97.251c-.656.139-1.3.327-1.922.564L7.05 5.444h9.902v3.659h-6.204l-.138 3.201a3.79 3.79 0 0 1 .754-.213c.24-.048.485-.073.73-.077a6.193 6.193 0 0 1 2.36.42 4.709 4.709 0 0 1 1.735 1.189 5.246 5.246 0 0 1 1.079 1.836c.263.795.389 1.623.373 2.455z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_44",
    x: 386,
    y: 114,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-17.1%",
    y: "-11.2%",
    width: "134.2%",
    height: "126.5%",
    id: "bna"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "bnb",
    width: 38,
    height: 49,
    rx: 4
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#bna)",
    href: "#bnb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    href: "#bnb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.531 31.583S9.43 38.338 9.43 40.516c.048 1.57 1.43 2.807 3.087 2.764 1.09.02 2.111-.503 2.692-1.378l-.637 1.463-1.149 1.83h4.227s-.745-1.098-1.122-1.83c-.197-.365-.448-.978-.655-1.488.573.885 1.597 1.419 2.693 1.403a3.09 3.09 0 0 0 2.143-.777 2.777 2.777 0 0 0 .935-1.987c-.01-2.178-6.112-8.933-6.112-8.933zm3.851-23.139-3.607 6.38c.136-.07.283-.116.434-.137.188-.015.377-.015.565 0 .743-.02 1.48.142 2.143.473a4.377 4.377 0 0 1 1.548 1.29 5.58 5.58 0 0 1 .875 1.915 9.24 9.24 0 0 1 .301 2.412 8.363 8.363 0 0 1-.448 2.861 5.867 5.867 0 0 1-1.262 2.106 5.42 5.42 0 0 1-1.919 1.305 6.448 6.448 0 0 1-2.422.45 6.856 6.856 0 0 1-2.477-.434 5.228 5.228 0 0 1-1.942-1.29c-.565-.596-1-1.3-1.277-2.068a7.987 7.987 0 0 1-.464-2.824 10.064 10.064 0 0 1 .449-3.052 15.86 15.86 0 0 1 1.13-2.671l3.552-6.716h4.82zm-3.823 9.219a1.752 1.752 0 0 0-1.455.87 3.858 3.858 0 0 0-.588 2.213 3.896 3.896 0 0 0 .588 2.198 1.68 1.68 0 0 0 1.478.87c.617 0 1.185-.334 1.478-.87a3.95 3.95 0 0 0 .526-2.198 4.158 4.158 0 0 0-.534-2.228 1.684 1.684 0 0 0-1.493-.855z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_45",
    x: 386,
    y: 171,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "boa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#boa)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.531 28.583S5.43 35.338 5.43 37.516c.048 1.57 1.43 2.807 3.087 2.764 1.09.02 2.111-.503 2.692-1.378l-.637 1.463-1.149 1.83h4.227s-.745-1.098-1.122-1.83c-.197-.365-.448-.978-.655-1.488.573.885 1.597 1.419 2.693 1.403a3.09 3.09 0 0 0 2.143-.777 2.777 2.777 0 0 0 .935-1.987c-.01-2.178-6.112-8.933-6.112-8.933zm.013-4.083H6.42l6.125-15.244H5.429V5.444h12.214v3.232z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_46",
    x: 386,
    y: 228,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "bpa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bpa)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.531 28.583S5.43 35.338 5.43 37.516c.048 1.57 1.43 2.807 3.087 2.764 1.09.02 2.111-.503 2.692-1.378-.215.52-.467 1.132-.637 1.463-.368.647-1.149 1.83-1.149 1.83h4.227s-.745-1.098-1.122-1.83c-.197-.365-.448-.978-.655-1.488.573.885 1.597 1.419 2.693 1.403a3.09 3.09 0 0 0 2.143-.777 2.777 2.777 0 0 0 .935-1.987c-.01-2.178-6.112-8.933-6.112-8.933zm6.111-9.609a5.488 5.488 0 0 1-.43 2.195 5.15 5.15 0 0 1-1.234 1.745 5.738 5.738 0 0 1-1.93 1.159 7.328 7.328 0 0 1-2.563.426 7.192 7.192 0 0 1-2.532-.426 5.703 5.703 0 0 1-1.898-1.159A5.07 5.07 0 0 1 5.85 21.17a5.614 5.614 0 0 1-.421-2.195 4.997 4.997 0 0 1 .25-1.661 4.65 4.65 0 0 1 .664-1.303c.253-.362.57-.677.937-.93.335-.236.7-.428 1.086-.572v-.053a3.887 3.887 0 0 1-1.906-1.524 4.44 4.44 0 0 1-.664-2.492 4.95 4.95 0 0 1 .36-1.86c.23-.6.583-1.147 1.038-1.608a5.212 5.212 0 0 1 1.774-1.12 6.841 6.841 0 0 1 2.508-.404 6.872 6.872 0 0 1 2.508.427c.674.244 1.29.617 1.813 1.097.477.454.852.999 1.102 1.6.244.591.369 1.223.367 1.86.03.875-.198 1.74-.656 2.492a3.948 3.948 0 0 1-1.883 1.524v.054a4.82 4.82 0 0 1 1.086.579c.36.26.676.574.937.93.287.394.506.832.649 1.295.17.54.252 1.104.242 1.67zm-4.266-.228a3.172 3.172 0 0 0-.524-1.868c-.3-.46-.82-.74-1.379-.74s-1.08.28-1.379.74a3.171 3.171 0 0 0-.523 1.898 3.223 3.223 0 0 0 .5 1.867 1.7 1.7 0 0 0 1.41.742 1.7 1.7 0 0 0 1.41-.742 3.34 3.34 0 0 0 .485-1.897zm-.156-7.964a2.916 2.916 0 0 0-.446-1.67 1.472 1.472 0 0 0-1.297-.655 1.432 1.432 0 0 0-1.29.656 2.99 2.99 0 0 0-.437 1.669c-.01.581.153 1.153.47 1.646.247.451.732.73 1.257.724a1.437 1.437 0 0 0 1.282-.724 2.992 2.992 0 0 0 .46-1.646z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_47",
    y: 339,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-17.1%",
    y: "-11.2%",
    width: "134.2%",
    height: "126.5%",
    id: "bqa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "bqb",
    width: 38,
    height: 49,
    rx: 4
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#bqa)",
    href: "#bqb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    href: "#bqb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.531 31.583S9.43 38.338 9.43 40.516c.048 1.57 1.43 2.807 3.087 2.764 1.09.02 2.111-.503 2.692-1.378l-.637 1.463-1.149 1.83h4.227s-.745-1.098-1.122-1.83c-.197-.365-.448-.978-.655-1.488.573.885 1.597 1.419 2.693 1.403a3.09 3.09 0 0 0 2.143-.777 2.777 2.777 0 0 0 .935-1.987c-.01-2.178-6.112-8.933-6.112-8.933zm-1.17-10.551a4.62 4.62 0 0 1-2.156-.474 4.572 4.572 0 0 1-1.546-1.28 5.446 5.446 0 0 1-.92-1.919 9.007 9.007 0 0 1-.309-2.376c-.02-.966.14-1.927.472-2.834a5.75 5.75 0 0 1 1.306-2.057 5.306 5.306 0 0 1 1.955-1.227 6.773 6.773 0 0 1 2.404-.42 6.45 6.45 0 0 1 2.404.42 5.408 5.408 0 0 1 1.932 1.265c.561.59.995 1.291 1.275 2.058.323.901.48 1.853.464 2.81a10.065 10.065 0 0 1-.449 3.107c-.3.91-.678 1.794-1.128 2.64L16.518 27.5h-4.816l3.656-6.623a1.302 1.302 0 0 1-.433.132 2.954 2.954 0 0 1-.564.023zm-.865-5.956a4.03 4.03 0 0 0 .571 2.167c.312.523.878.84 1.484.83a1.745 1.745 0 0 0 1.484-.846c.4-.643.594-1.393.557-2.15a3.725 3.725 0 0 0-.58-2.175 1.722 1.722 0 0 0-1.468-.83 1.698 1.698 0 0 0-1.477.792 3.78 3.78 0 0 0-.571 2.212z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_48",
    x: 46,
    y: 339,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-17.1%",
    y: "-11.2%",
    width: "134.2%",
    height: "126.5%",
    id: "bra"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "brb",
    width: 38,
    height: 49,
    rx: 4
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#bra)",
    href: "#brb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    href: "#brb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.531 31.583S9.43 38.338 9.43 40.516c.048 1.57 1.43 2.807 3.087 2.764 1.09.02 2.111-.503 2.692-1.378l-.637 1.463-1.149 1.83h4.227s-.745-1.098-1.122-1.83c-.197-.365-.448-.978-.655-1.488.573.885 1.597 1.419 2.693 1.403a3.09 3.09 0 0 0 2.143-.777 2.777 2.777 0 0 0 .935-1.987c-.01-2.178-6.112-8.933-6.112-8.933zm16.714-16.861a10.74 10.74 0 0 0-.919-3.086 6.2 6.2 0 0 0-1.86-2.281 4.949 4.949 0 0 0-3.089-.905 4.926 4.926 0 0 0-3.088.905 6.215 6.215 0 0 0-1.868 2.28 10.74 10.74 0 0 0-.904 3.087 23.73 23.73 0 0 0-.231 3.262c.006 1.081.086 2.16.24 3.231.142 1.07.446 2.113.902 3.095a6.215 6.215 0 0 0 1.869 2.28 4.972 4.972 0 0 0 3.088.905 4.996 4.996 0 0 0 3.088-.905 6.2 6.2 0 0 0 1.861-2.28 10.73 10.73 0 0 0 .919-3.095c.33-2.142.33-4.32 0-6.462l-.008-.03zm-4.015 5.2a11.19 11.19 0 0 1-.278 1.901c-.111.51-.307.998-.579 1.445a1.12 1.12 0 0 1-.996.585 1.139 1.139 0 0 1-.996-.547 4.732 4.732 0 0 1-.579-1.445 10.649 10.649 0 0 1-.27-1.9 29.478 29.478 0 0 1-.07-1.97c0-.623 0-1.246.07-1.938a10.96 10.96 0 0 1 .27-1.908 4.753 4.753 0 0 1 .58-1.483c.197-.36.58-.585.995-.586s.8.223.996.586c.273.452.469.945.58 1.46a11.81 11.81 0 0 1 .277 1.908 28.44 28.44 0 0 1 .062 1.939c0 .6-.015 1.262-.062 1.954zM9.429 12.268l1.871 3.333 2.803-2.153V27.5h4.147V8.444h-3.696z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_49",
    x: 92,
    y: 339,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "bsa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bsa)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.531 28.583S5.43 35.338 5.43 37.516c.048 1.57 1.43 2.807 3.087 2.764 1.09.02 2.111-.503 2.692-1.378l-.637 1.463-1.149 1.83h4.227s-.745-1.098-1.122-1.83c-.197-.365-.448-.978-.655-1.488.573.885 1.597 1.419 2.693 1.403a3.09 3.09 0 0 0 2.143-.777 2.777 2.777 0 0 0 .935-1.987c-.01-2.178-6.112-8.933-6.112-8.933zm4.569-5.81c-1.164 1.19-2.938 1.829-4.759 1.714-1.4.033-2.768-.358-3.857-1.103-1.063-.757-1.788-1.799-2.055-2.952l3.96-1.5c.11.398.31.772.591 1.104.244.301.648.482 1.08.484.585.047 1.133-.247 1.332-.714a4.85 4.85 0 0 0 .32-1.968V5.444h4.917V18.14c.11 1.645-.429 3.275-1.53 4.634z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_5",
    x: 138,
    y: 339,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "bta"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bta)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 34c-.8 0-2 .6-2.8 1.3.9-1 2.1-2.6 2.1-3.6a3 3 0 0 0-3-3.1 3 3 0 0 0-3 3c0 1.1 1.2 2.8 2 3.8-.8-.8-2-1.5-2.7-1.5a3 3 0 0 0-3 3 3 3 0 0 0 3 3.1c1 0 2.3-1 3.3-1.9a27 27 0 0 1-.7 2l-1.2 2h4.5l-1.2-2-.7-2c1 .9 2.4 2 3.4 2a3 3 0 0 0 2.7-1.6 3 3 0 0 0 0-3 3 3 0 0 0-2.7-1.6zm-.5-28.6-3.6 6.4.4-.1h.6a4.5 4.5 0 0 1 3.7 1.7c.4.6.7 1.3.8 2a9.2 9.2 0 0 1-.1 5.2c-.3.8-.7 1.5-1.3 2.1-.5.6-1.2 1-1.9 1.3-.8.4-1.6.5-2.4.5-.9 0-1.7-.1-2.5-.4-.7-.3-1.4-.8-2-1.3a6 6 0 0 1-1.2-2 10 10 0 0 1 0-5.9L7 12.1l3.6-6.8h4.8zm-3.8 9.3c-.6 0-1.2.3-1.5.8-.4.7-.6 1.5-.6 2.2 0 .8.2 1.6.6 2.2a1.7 1.7 0 0 0 3 0 4 4 0 0 0 .5-2.2c0-.7-.2-1.5-.5-2.2-.3-.5-1-.8-1.5-.8z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_50",
    x: 184,
    y: 339,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-17.1%",
    y: "-11.2%",
    width: "134.2%",
    height: "126.5%",
    id: "bua"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "bub",
    width: 38,
    height: 49,
    rx: 4
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#bua)",
    href: "#bub"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    href: "#bub"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.531 31.583S9.43 38.338 9.43 40.516c.048 1.57 1.43 2.807 3.087 2.764 1.09.02 2.111-.503 2.692-1.378l-.637 1.463-1.149 1.83h4.227s-.745-1.098-1.122-1.83c-.197-.365-.448-.978-.655-1.488.573.885 1.597 1.419 2.693 1.403a3.09 3.09 0 0 0 2.143-.777 2.777 2.777 0 0 0 .935-1.987c-.01-2.178-6.112-8.933-6.112-8.933zm5.649-7.077a9.202 9.202 0 0 0 1.344-2.961 14.69 14.69 0 0 0 .475-3.842 14.355 14.355 0 0 0-.475-3.817 9.097 9.097 0 0 0-1.345-2.93 6.197 6.197 0 0 0-2.142-1.88 6.037 6.037 0 0 0-2.826-.63 6.158 6.158 0 0 0-2.867.662 6.245 6.245 0 0 0-2.134 1.88 9.089 9.089 0 0 0-1.337 2.93 14.719 14.719 0 0 0-.443 3.785 14.719 14.719 0 0 0 .475 3.842 9.202 9.202 0 0 0 1.345 2.961 6.238 6.238 0 0 0 2.134 1.905 5.79 5.79 0 0 0 1.772.581l.265.412a7.32 7.32 0 0 0 1.804 1.824 5.63 5.63 0 0 0 2.175.904 5.2 5.2 0 0 0 1.932 0v-3.124a2.017 2.017 0 0 1-1.61 0 2.842 2.842 0 0 1-.854-.548l.145-.073a6.189 6.189 0 0 0 2.166-1.88zm-2.424-4.398a7.088 7.088 0 0 1-.527 1.731c-.185.438-.466.83-.822 1.149a1.81 1.81 0 0 1-1.193.429 1.894 1.894 0 0 1-1.217-.43 3.237 3.237 0 0 1-.822-1.148 6.447 6.447 0 0 1-.51-1.731 12.816 12.816 0 0 1-.164-2.16 12.49 12.49 0 0 1 .164-2.144c.088-.595.26-1.174.51-1.723a3.15 3.15 0 0 1 .822-1.14 1.92 1.92 0 0 1 1.217-.413c.435-.007.858.14 1.193.413.358.314.64.704.822 1.14a7.01 7.01 0 0 1 .527 1.723c.119.709.177 1.426.172 2.144a12.786 12.786 0 0 1-.205 2.16h.033z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_51",
    x: 230,
    y: 339,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "bva"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bva)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.531 28.583S5.43 35.338 5.43 37.516c.048 1.57 1.43 2.807 3.087 2.764 1.09.02 2.111-.503 2.692-1.378l-.637 1.463-1.149 1.83h4.227s-.745-1.098-1.122-1.83c-.197-.365-.448-.978-.655-1.488.573.885 1.597 1.419 2.693 1.403a3.09 3.09 0 0 0 2.143-.777 2.777 2.777 0 0 0 .935-1.987c-.01-2.178-6.112-8.933-6.112-8.933zM13.97 24.5l-4.103-8.845h-.08V24.5H5.43V5.444h4.366v7.94h.08l3.992-7.94h4.854l-4.966 8.734L19 24.5z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_6",
    x: 276,
    y: 339,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "bwa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bwa)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 34c-.8 0-2 .6-2.8 1.3.9-1 2.1-2.6 2.1-3.6a3 3 0 0 0-3-3.1 3 3 0 0 0-3 3c0 1.1 1.2 2.8 2 3.8-.8-.8-2-1.5-2.7-1.5a3 3 0 0 0-3 3 3 3 0 0 0 3 3.1c1 0 2.3-1 3.3-1.9a27 27 0 0 1-.7 2l-1.2 2h4.5l-1.2-2-.7-2c1 .9 2.4 2 3.4 2a3 3 0 0 0 2.7-1.6 3 3 0 0 0 0-3 3 3 0 0 0-2.7-1.6zm-4.4-9.5h-5l6-15.2h-7V5.4h12.1v3.3z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_7",
    x: 322,
    y: 339,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.6%",
    y: "-21.4%",
    width: "155.3%",
    height: "142.9%",
    id: "bxa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0",
    result: "C"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "C"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bxa)",
    transform: "translate(4 3)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 38,
    height: 49,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 34c-.8 0-2 .6-2.8 1.3.9-1 2.1-2.6 2.1-3.6a3 3 0 0 0-3-3.1 3 3 0 0 0-3 3c0 1.1 1.2 2.8 2 3.8-.8-.8-2-1.5-2.7-1.5a3 3 0 0 0-3 3 3 3 0 0 0 3 3.1c1 0 2.3-1 3.3-1.9a27 27 0 0 1-.7 2l-1.2 2h4.5l-1.2-2-.7-2c1 .9 2.4 2 3.4 2a3 3 0 0 0 2.7-1.6 3 3 0 0 0 0-3 3 3 0 0 0-2.7-1.6zm1.7-15c0 .7-.1 1.5-.4 2.2-.3.6-.7 1.2-1.2 1.7-.6.5-1.2 1-2 1.2-.8.3-1.6.4-2.5.4-.9 0-1.7-.1-2.5-.4-.8-.3-1.4-.7-2-1.2a5 5 0 0 1-1-1.7 5.6 5.6 0 0 1 .4-5.2l1-1 1-.5c-.7-.3-1.4-.9-1.8-1.6a5 5 0 0 1 .7-6 6.8 6.8 0 0 1 4.3-1.5c.8 0 1.7.2 2.5.5.7.2 1.3.6 1.8 1a4.7 4.7 0 0 1 1.5 3.5c0 1-.2 1.8-.7 2.5a4 4 0 0 1-1.9 1.5v.1c.4.1.8.3 1.1.6a4.3 4.3 0 0 1 1.6 2.2c.2.5.3 1.1.2 1.7zm-4.2-.3c0-.6-.2-1.3-.5-1.8s-.9-.8-1.4-.8c-.6 0-1.1.3-1.4.8-.4.5-.6 1.2-.5 1.9 0 .6.1 1.3.5 1.8.3.5.8.8 1.4.8.5 0 1-.3 1.4-.8.3-.5.5-1.2.5-1.9zm-.2-8a3 3 0 0 0-.4-1.6c-.3-.4-.8-.7-1.3-.6-.5 0-1 .2-1.3.6a3 3 0 0 0-.4 1.7c0 .6.1 1.1.4 1.6.3.5.8.8 1.3.8s1-.3 1.3-.8c.3-.5.4-1 .4-1.6z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_8",
    x: 368,
    y: 339,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-17.1%",
    y: "-11.2%",
    width: "134.2%",
    height: "126.5%",
    id: "bya"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "byb",
    width: 38,
    height: 49,
    rx: 4
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#bya)",
    href: "#byb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    href: "#byb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.9 37c-.8 0-2 .6-2.8 1.3.9-1 2.1-2.6 2.1-3.6a3 3 0 0 0-3-3.1 3 3 0 0 0-3 3c0 1.1 1.2 2.8 2 3.8-.8-.8-2-1.5-2.7-1.5a3 3 0 0 0-3 3 3 3 0 0 0 3 3.1c1 0 2.3-1 3.3-1.9a27 27 0 0 1-.7 2l-1.2 2h4.5l-1.2-2-.7-2c1 .9 2.4 2 3.4 2a3 3 0 0 0 2.7-1.6 3 3 0 0 0 0-3 3 3 0 0 0-2.7-1.6zm-5.5-16c-.8 0-1.5-.1-2.2-.4-.6-.3-1.1-.8-1.5-1.3-.5-.6-.8-1.2-1-2a9 9 0 0 1 .2-5.2c.3-.7.7-1.4 1.3-2 .6-.6 1.2-1 2-1.2a6.4 6.4 0 0 1 4.8 0 5.4 5.4 0 0 1 3.2 3.3c.3.9.5 1.8.4 2.8 0 1-.1 2.1-.4 3.1a17 17 0 0 1-1.1 2.6l-3.6 6.8h-4.8l3.7-6.6-.5.1a3 3 0 0 1-.5 0zm-.9-6c0 .8.2 1.6.6 2.2.3.6.8.9 1.5.9.6 0 1.1-.4 1.4-.9.4-.6.6-1.4.6-2.1 0-.8-.2-1.6-.6-2.2-.3-.5-.9-.8-1.5-.8s-1.1.3-1.4.8c-.4.6-.6 1.4-.6 2.2z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_9",
    x: 432,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-17.1%",
    y: "-11.2%",
    width: "134.2%",
    height: "126.5%",
    id: "bza"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "bzb",
    width: 38,
    height: 49,
    rx: 4
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#bza)",
    href: "#bzb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    href: "#bzb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.9 37c-.8 0-2 .6-2.8 1.3.9-1 2.1-2.6 2.1-3.6a3 3 0 0 0-3-3.1 3 3 0 0 0-3 3c0 1.1 1.2 2.8 2 3.8-.8-.8-2-1.5-2.7-1.5a3 3 0 0 0-3 3 3 3 0 0 0 3 3.1c1 0 2.3-1 3.3-1.9a27 27 0 0 1-.7 2l-1.2 2h4.5l-1.2-2-.7-2c1 .9 2.4 2 3.4 2a3 3 0 0 0 2.7-1.6 3 3 0 0 0 0-3 3 3 0 0 0-2.7-1.6zm12.3-22.3c-.1-1-.4-2-.9-3-.4-1-1-1.7-1.8-2.3a5 5 0 0 0-3.1-1 5 5 0 0 0-3.1 1c-.8.6-1.5 1.3-1.9 2.2-.4 1-.7 2-.9 3.1a23.8 23.8 0 0 0 0 6.5c.2 1 .5 2.1 1 3.1a5 5 0 0 0 5 3.2 5 5 0 0 0 3-1c.8-.5 1.4-1.3 1.8-2.2.5-1 .8-2 1-3 .3-2.2.3-4.4 0-6.5zm-4 5.2-.2 2-.6 1.4c-.2.3-.6.6-1 .6s-.8-.2-1-.6c-.3-.4-.5-1-.6-1.4l-.3-2v-3.8c0-.7.2-1.3.3-2 .1-.5.3-1 .6-1.4a1.1 1.1 0 0 1 2 0L28 14l.2 2a28.9 28.9 0 0 1 0 3.8zM9.4 12.3l1.9 3.3 2.8-2.2v14.1h4.2v-19h-3.7z",
    fill: "#1e1e1e",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 111,
    fill: "none",
    viewBox: "0 0 78 111",
    id: "card_simple_omaha_back",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cba)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.322 101.921H63.29a5.322 5.322 0 0 0 5.323-5.322V14.987a5.323 5.323 0 0 0-5.323-5.322H14.322A5.323 5.323 0 0 0 9 14.987V96.6a5.322 5.322 0 0 0 5.322 5.322Z",
    fill: "#2D2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.78 96.161h41.986a3.726 3.726 0 0 0 3.727-3.726v-73.33a3.726 3.726 0 0 0-3.727-3.727H17.78a3.726 3.726 0 0 0-3.726 3.727v73.33a3.726 3.726 0 0 0 3.726 3.726Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8 16.935h41.806a2.299 2.299 0 0 1 2.296 2.296v73.08a2.299 2.299 0 0 1-2.296 2.295H17.801a2.299 2.299 0 0 1-2.296-2.295V19.23a2.299 2.299 0 0 1 2.296-2.296Zm0-.728a3.033 3.033 0 0 0-3.024 3.024v73.08a3.033 3.033 0 0 0 3.025 3.024h41.805a3.033 3.033 0 0 0 3.025-3.024V19.23a3.033 3.033 0 0 0-3.025-3.024H17.801Z",
    fill: "#EBD692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.472 55.77a3.256 3.256 0 1 0 6.515 0c0-1.8-1.458-3.258-3.258-3.258a3.256 3.256 0 0 0-3.257 3.258Zm.532 0a2.728 2.728 0 0 1 2.725-2.726 2.728 2.728 0 0 1 2.726 2.726 2.728 2.728 0 0 1-2.726 2.725 2.728 2.728 0 0 1-2.725-2.725Z",
    fill: "#EBD692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.922 55.77a1.807 1.807 0 1 0 3.614 0 1.807 1.807 0 0 0-3.614 0Zm.71 0a1.1 1.1 0 0 1 1.097-1.098 1.1 1.1 0 0 1 1.098 1.098 1.1 1.1 0 0 1-1.098 1.098 1.1 1.1 0 0 1-1.098-1.098ZM30.154 50.953a.917.917 0 1 0 1.833-.001.917.917 0 0 0-1.833 0Zm.532 0a.385.385 0 0 1 .767 0 .385.385 0 0 1-.767 0Z",
    fill: "#EBD692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.785 55.77a4.943 4.943 0 1 0 9.887 0 4.943 4.943 0 0 0-9.886 0Zm.71 0a4.24 4.24 0 0 1 4.234-4.234 4.24 4.24 0 0 1 4.234 4.234 4.24 4.24 0 0 1-4.234 4.234 4.24 4.24 0 0 1-4.234-4.234ZM24.188 45.985c0-.62-.506-1.125-1.125-1.125-.62 0-1.125.505-1.125 1.125s.505 1.125 1.125 1.125 1.125-.506 1.125-1.125Zm-.532 0a.592.592 0 1 1-1.184.002.592.592 0 0 1 1.184-.002ZM54.194 44.8c-.62 0-1.125.505-1.125 1.124 0 .62.505 1.125 1.125 1.125s1.125-.505 1.125-1.125c0-.619-.506-1.124-1.125-1.124Zm0 .532a.592.592 0 1 1 .001 1.184.592.592 0 0 1-.001-1.184ZM41.87 42.492c.015-.139.275-3.161-3.014-7.687l-.287-.396-.287.396c-3.291 4.528-3.199 7.54-3.194 7.667h.027a3.383 3.383 0 0 0 3.379 3.365 3.376 3.376 0 0 0 3.377-3.343v-.002Zm-.706-.071.347.034h-.347a2.673 2.673 0 0 1-2.67 2.67 2.673 2.673 0 0 1-2.67-2.67h-.381l.354-.014c0-.027-.065-2.736 2.772-6.817 2.818 4.069 2.6 6.768 2.597 6.795l-.002.002Z",
    fill: "#EBD692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.077 42.421a1.687 1.687 0 0 0-3.371 0 1.687 1.687 0 0 0 3.371 0Zm-.532 0a1.155 1.155 0 0 1-2.307 0 1.155 1.155 0 0 1 2.307 0ZM38.57 40.07a.575.575 0 1 1-.001-1.151.575.575 0 0 1 0 1.15ZM38.57 28.317a.575.575 0 1 1 0 1.15.575.575 0 0 1 0-1.15ZM26.87 53.972a.575.575 0 1 1-1.15.001.575.575 0 0 1 1.15 0ZM38.569 38.282a.413.413 0 1 1 0-.826.413.413 0 0 1 0 .825ZM19.307 49.544a.255.255 0 1 0 0-.51.255.255 0 0 0 0 .51ZM18.775 47.89a.255.255 0 1 1 0 .51.255.255 0 0 1 0-.51ZM26.294 57.832a.255.255 0 1 0 0-.51.255.255 0 0 0 0 .51ZM50.859 58.087a.255.255 0 1 0 0-.51.255.255 0 0 0 0 .51Z",
    fill: "#EBD692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.392 42.674a.255.255 0 1 1 0-.51.255.255 0 0 1 0 .51ZM36.706 68.951a1.687 1.687 0 0 0 3.371 0 1.687 1.687 0 0 0-3.371 0Zm.532 0a1.155 1.155 0 0 1 2.307 0 1.155 1.155 0 0 1-2.307 0ZM38.57 71.303a.575.575 0 1 1 0 1.15.575.575 0 0 1 0-1.15ZM38.569 73.09a.413.413 0 1 1 0 .826.413.413 0 0 1 0-.825ZM38.746 55.318a.413.413 0 1 1 .001.826.413.413 0 0 1 0-.826Z",
    fill: "#EBD692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.392 68.696a.255.255 0 1 1 0 .51.255.255 0 0 1 0-.51ZM26.549 47.794c0-.194.155-.35.35-.35.194 0 .35.156.35.35 0 .195-.156.35-.35.35a.348.348 0 0 1-.35-.35ZM26.372 48.587c.194 0 .35.155.35.35 0 .194-.156.35-.35.35a.348.348 0 0 1-.35-.35c0-.195.155-.35.35-.35ZM29.015 38.843a.43.43 0 1 0 0-.86.43.43 0 0 0 0 .86ZM23.167 29.947a.43.43 0 1 0 0-.86.43.43 0 0 0 0 .86ZM17.043 29.947a.43.43 0 1 0 0-.86.43.43 0 0 0 0 .86ZM60.342 29.947a.43.43 0 1 1-.001-.859.43.43 0 0 1 .001.859ZM17.043 81.76a.43.43 0 1 1 .002.86.43.43 0 0 1-.002-.86ZM59.912 82.19a.43.43 0 1 1 .859 0 .43.43 0 0 1-.859 0ZM53.662 29.947a.43.43 0 1 0 0-.86.43.43 0 0 0 0 .86ZM27.997 38.925a.764.764 0 0 1 0 1.526.764.764 0 0 1-.763-.763c0-.42.343-.763.763-.763ZM26.199 39.912a.538.538 0 1 1 0 1.078.538.538 0 1 1 0-1.078ZM24.637 38.957a.434.434 0 1 1 0 .869.434.434 0 0 1 0-.87ZM24.178 37.689a.433.433 0 0 1-.865 0 .433.433 0 0 1 .865 0ZM23.923 36.435a.432.432 0 1 0 0-.864.432.432 0 0 0 0 .864ZM24.814 34.842a.432.432 0 1 0 0-.865.432.432 0 0 0 0 .865ZM26.372 33.977a.433.433 0 0 1 0-.865.433.433 0 0 1 0 .865ZM27.997 33.72a.432.432 0 1 0 0-.865.432.432 0 0 0 0 .865ZM29.574 34.154a.432.432 0 1 0 0-.864.432.432 0 0 0 0 .864ZM30.805 35.682a.433.433 0 0 1 0-.864.433.433 0 0 1 0 .864ZM31.123 37.174a.433.433 0 0 1 .865 0 .433.433 0 0 1-.865 0ZM26.976 46.993a.255.255 0 1 0 0-.51.255.255 0 0 0 0 .51ZM26.721 45.827a.255.255 0 1 0 0-.51.255.255 0 0 0 0 .51ZM26.204 44.824a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5ZM25.363 43.84a.177.177 0 1 0 0-.355.177.177 0 0 0 0 .355ZM18.328 46.816c.098 0 .178.08.178.177 0 .097-.08.178-.178.178a.178.178 0 0 1-.177-.178c0-.097.08-.177.177-.177ZM24.637 43.395a.177.177 0 1 0 0-.354.177.177 0 0 0 0 .354ZM23.745 43.16a.177.177 0 1 0 0-.355.177.177 0 0 0 0 .355ZM22.752 43.092a.143.143 0 1 0 0-.287.143.143 0 0 0 0 .287ZM18.15 45.842a.144.144 0 1 1 0 .287.144.144 0 0 1 0-.287ZM21.858 43.303a.143.143 0 1 0 0-.286.143.143 0 0 0 0 .286Z",
    fill: "#EBD692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.87 69.01a3.371 3.371 0 0 0-.995-2.36 3.373 3.373 0 0 0-2.398-1 3.383 3.383 0 0 0-3.38 3.379h.02v.005h-.027c-.005.123-.097 3.138 3.195 7.666l.287.396.286-.396c3.29-4.528 3.03-7.547 3.015-7.686l-.002-.005Zm-6.073.048-.354-.015h.381a2.673 2.673 0 0 1 2.67-2.67c.731 0 1.397.297 1.88.775.476.484.773 1.145.773 1.876h.017v.017h.347l-.348.034c.003.026.222 2.728-2.596 6.794-2.838-4.08-2.772-6.79-2.772-6.816l.002.005ZM22.572 50.892c-1.52 0-2.648-.71-2.648-.71 1.353 2.66 2.107 3.49 2.107 3.49 1.753-1.925 2.803-3.105 3.335-3.69-.97.69-1.941.91-2.791.91h-.003Zm-1.491.333c.43.114.937.2 1.491.2.285 0 .561-.023.836-.066-.384.425-.829.918-1.339 1.479-.228-.33-.56-.848-.988-1.613ZM20.041 41.503c.083-1.681.95-3.36.95-3.36.005 1.327 1.076 2.488 1.044 2.485-1.523-.177-1.994.875-1.994.875ZM28.837 43.662s.25 2.646 4.949 5.702c0 0-3.814-3.012-3.413-6.766 0 0-.632.926-1.533 1.064h-.003Zm1.013.163a6.79 6.79 0 0 0 .399 1.623c-.43-.61-.654-1.103-.768-1.424.131-.058.255-.126.37-.199ZM30.37 47.795c-1.015 0-1.533.998-1.533.998.358-.71.518-2.308.518-2.308.107.668 1.015 1.31 1.015 1.31ZM29.445 55.77l-.838.663-.61-.663.61-.66.838.66ZM24.647 55.845l-.61.661-.624-.66h-.003l.003-.003.624-.66.61.662ZM46.258 50.037a.917.917 0 1 0 .001 1.833.917.917 0 0 0-.001-1.833Zm0 .532a.385.385 0 0 1 0 .768.385.385 0 0 1 0-.768ZM51.036 54.55a.575.575 0 1 1 0-1.15.575.575 0 0 1 0 1.15ZM58.02 49.544a.255.255 0 1 0 0-.51.255.255 0 0 0 0 .51ZM58.555 48.4a.255.255 0 1 0 0-.51.255.255 0 0 0 0 .51ZM50.429 47.445c.194 0 .35.155.35.35 0 .194-.156.35-.35.35a.35.35 0 0 1 0-.7ZM50.956 49.289a.348.348 0 0 1-.35-.35c0-.194.155-.35.35-.35.194 0 .35.156.35.35 0 .194-.156.35-.35.35ZM48.313 38.843a.43.43 0 1 0 0-.86.43.43 0 0 0 0 .86ZM49.333 40.451a.764.764 0 0 1-.763-.763.764.764 0 0 1 1.526 0c0 .42-.343.763-.763.763ZM51.129 40.99a.538.538 0 1 1 0-1.078.538.538 0 1 1 0 1.078ZM52.693 38.957a.434.434 0 1 1 0 .869.434.434 0 0 1 0-.87ZM53.584 37.257a.433.433 0 0 1 0 .864.433.433 0 0 1 0-.864ZM53.407 36.435a.432.432 0 1 0 0-.864.432.432 0 0 0 0 .864ZM52.516 34.842a.432.432 0 1 0 0-.865.432.432 0 0 0 0 .865ZM50.956 33.977a.432.432 0 1 0 0-.865.432.432 0 0 0 0 .865ZM49.333 33.72a.432.432 0 1 0 0-.865.432.432 0 0 0 0 .865ZM47.757 34.154a.432.432 0 1 0 0-.864.432.432 0 0 0 0 .864ZM46.092 35.25a.433.433 0 0 1 .865 0 .433.433 0 0 1-.865 0ZM45.774 37.606a.433.433 0 0 1 0-.864.433.433 0 0 1 0 .864ZM50.353 46.993a.255.255 0 1 0 0-.51.255.255 0 0 0 0 .51ZM50.606 45.827a.255.255 0 1 0 0-.51.255.255 0 0 0 0 .51ZM51.126 44.324a.25.25 0 1 1 0 .5.25.25 0 0 1 0-.5ZM51.966 43.84a.177.177 0 1 0 0-.355.177.177 0 0 0 0 .355ZM59.177 46.993c0 .097-.08.178-.178.178a.178.178 0 0 1-.177-.178c0-.097.08-.177.177-.177.097 0 .178.08.178.177ZM52.693 43.395a.177.177 0 1 0 0-.354.177.177 0 0 0 0 .354ZM53.584 43.16a.177.177 0 1 0 0-.355.177.177 0 0 0 0 .355ZM54.578 42.805a.144.144 0 1 1 0 .287.144.144 0 0 1 0-.287ZM59.176 46.129a.144.144 0 1 1 .001-.288.144.144 0 0 1 0 .288ZM55.47 43.303a.143.143 0 1 0 0-.286.143.143 0 0 0 0 .286ZM55.302 53.671s.753-.828 2.106-3.488c0 0-1.127.71-2.648.71-.85 0-1.822-.222-2.791-.912.53.586 1.581 1.766 3.335 3.69h-.002Zm.947-2.448c-.427.765-.76 1.285-.989 1.613-.51-.562-.957-1.055-1.338-1.48.274.044.551.066.836.066.553 0 1.061-.085 1.491-.2ZM57.286 41.503s-.473-1.052-1.994-.875c-.03.003 1.042-1.158 1.044-2.485 0 0 .868 1.681.95 3.36ZM48.49 43.662c-.901-.136-1.533-1.064-1.533-1.064.398 3.754-3.413 6.766-3.413 6.766 4.696-3.059 4.948-5.702 4.948-5.702h-.002Zm-1.412 1.786a6.79 6.79 0 0 0 .399-1.623c.114.073.238.141.37.2-.115.32-.339.813-.769 1.425v-.002ZM46.957 47.795s.909-.644 1.016-1.31c0 0 .16 1.599.517 2.308 0 0-.517-.998-1.533-.998ZM30.988 59.946a.917.917 0 1 0 0 1.833.917.917 0 0 0 0-1.833Zm0 .532a.385.385 0 0 1 0 .768.385.385 0 0 1 0-.768ZM21.856 65.83c0 .62.505 1.125 1.124 1.125.62 0 1.125-.506 1.125-1.125 0-.62-.505-1.125-1.125-1.125s-1.124.505-1.124 1.125Zm.532 0a.592.592 0 1 1 1.184-.002.592.592 0 0 1-1.184.002ZM52.984 65.89c0 .62.505 1.125 1.125 1.125s1.125-.505 1.125-1.125-.506-1.124-1.125-1.124c-.62 0-1.125.505-1.125 1.124Zm.532 0a.592.592 0 1 1 1.184-.001.592.592 0 0 1-1.184.001ZM19.222 62.783a.255.255 0 1 0 0-.51.255.255 0 0 0 0 .51ZM18.69 63.925a.255.255 0 1 0 0-.51.255.255 0 0 0 0 .51ZM26.816 64.37a.348.348 0 0 1-.35-.35c0-.194.156-.35.35-.35.194 0 .35.155.35.35 0 .194-.156.35-.35.35ZM26.29 62.528c.194 0 .349.156.349.35 0 .194-.155.35-.35.35a.348.348 0 0 1-.35-.35c0-.194.156-.35.35-.35ZM28.932 73.832a.43.43 0 1 0 0-.86.43.43 0 0 0 0 .86ZM27.912 71.364c.42 0 .763.342.763.762s-.343.763-.763.763a.764.764 0 0 1-.763-.763c0-.42.342-.762.763-.762ZM26.117 70.824a.538.538 0 1 1 0 1.079.538.538 0 1 1 0-1.079ZM24.552 72.86a.435.435 0 1 1 0-.87.435.435 0 0 1 0 .87ZM23.66 74.558a.433.433 0 0 1 0-.865.433.433 0 0 1 0 .865ZM23.838 76.244a.432.432 0 1 0 0-.865.432.432 0 0 0 0 .865ZM24.73 77.838a.432.432 0 1 0 0-.865.432.432 0 0 0 0 .865ZM26.289 78.705a.433.433 0 0 1 0-.865.433.433 0 0 1 0 .865ZM27.912 78.96a.433.433 0 0 1 0-.865.433.433 0 0 1 0 .865ZM29.488 78.528a.433.433 0 0 1 0-.865.433.433 0 0 1 0 .865ZM30.72 76.997a.432.432 0 1 0 0-.865.432.432 0 0 0 0 .865ZM31.47 74.208a.433.433 0 0 1 0 .865.433.433 0 0 1 0-.865ZM26.892 65.331a.255.255 0 1 0 0-.51.255.255 0 0 0 0 .51ZM26.639 65.987a.255.255 0 1 1 0 .51.255.255 0 0 1 0-.51ZM26.37 67.241a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM25.278 68.329a.177.177 0 1 0 0-.355.177.177 0 0 0 0 .355ZM18.246 64.999a.177.177 0 1 0 0-.355.177.177 0 0 0 0 .355ZM24.552 68.774a.177.177 0 1 0 0-.355.177.177 0 0 0 0 .355ZM23.66 69.01a.177.177 0 1 0 0-.355.177.177 0 0 0 0 .355ZM22.667 69.01a.144.144 0 1 1 0-.288.144.144 0 0 1 0 .287ZM18.21 65.83a.144.144 0 1 1-.288-.001.144.144 0 0 1 .287 0ZM21.776 68.798a.143.143 0 1 0 0-.286.143.143 0 0 0 0 .286ZM21.943 58.143s-.753.829-2.106 3.489c0 0 1.127-.71 2.648-.71.85 0 1.822.222 2.79.911-.529-.585-1.58-1.766-3.334-3.69h.002Zm-.947 2.449c.427-.765.76-1.285.988-1.613.51.561.957 1.054 1.339 1.48a5.291 5.291 0 0 0-.836-.066c-.554 0-1.061.085-1.491.199ZM19.958 70.311s.474 1.052 1.995.875c.029-.002-1.043 1.159-1.045 2.485 0 0-.867-1.68-.95-3.36ZM33.7 62.45c-4.695 3.059-4.948 5.702-4.948 5.702.902.136 1.533 1.064 1.533 1.064-.398-3.753 3.413-6.766 3.413-6.766h.003Zm-3.536 3.916a6.792 6.792 0 0 0-.399 1.623 2.82 2.82 0 0 0-.369-.2c.114-.32.338-.813.768-1.425v.002ZM29.272 65.329s-.16-1.598-.517-2.308c0 0 .517.999 1.533.999 0 0-.909.643-1.016 1.309ZM46.175 59.946a.917.917 0 1 0 .001 1.833.917.917 0 0 0-.001-1.833Zm0 .532a.385.385 0 0 1 0 .768.385.385 0 0 1 0-.768ZM57.937 62.783a.255.255 0 1 0 0-.51.255.255 0 0 0 0 .51ZM58.47 63.925a.255.255 0 1 0 0-.51.255.255 0 0 0 0 .51ZM50.696 64.02c0 .194-.155.35-.35.35a.348.348 0 0 1-.35-.35c0-.194.156-.35.35-.35.195 0 .35.155.35.35ZM50.873 63.228a.348.348 0 0 1-.35-.35c0-.194.156-.35.35-.35.195 0 .35.156.35.35 0 .194-.155.35-.35.35ZM48.66 73.401a.43.43 0 1 1-.86 0 .43.43 0 1 1 .86 0ZM49.248 72.89a.764.764 0 0 1-.763-.764.764.764 0 0 1 1.526 0c0 .42-.343.763-.763.763ZM51.046 71.903a.538.538 0 1 1 0-1.079c.299 0 .539.24.539.54 0 .298-.24.539-.54.539ZM52.608 72.86a.434.434 0 1 1-.001-.87.434.434 0 0 1 0 .87ZM53.067 74.126a.433.433 0 0 1 .865 0 .433.433 0 0 1-.865 0ZM53.322 76.244a.432.432 0 1 0 0-.865.432.432 0 0 0 0 .865ZM52.43 77.838a.432.432 0 1 0 0-.865.432.432 0 0 0 0 .865ZM50.873 77.838a.433.433 0 0 1 0 .864.433.433 0 0 1 0-.864ZM49.248 78.96a.433.433 0 0 1 0-.865.433.433 0 0 1 0 .865ZM47.672 78.525a.432.432 0 1 0 0-.865.432.432 0 0 0 0 .865ZM46.44 76.997a.432.432 0 1 0 0-.865.432.432 0 0 0 0 .865ZM45.69 75.073a.432.432 0 1 0 0-.865.432.432 0 0 0 0 .865ZM50.268 65.331a.255.255 0 1 0 0-.51.255.255 0 0 0 0 .51ZM50.524 65.987a.255.255 0 1 1 0 .51.255.255 0 0 1 0-.51ZM51.04 66.99a.25.25 0 1 1 .001.5.25.25 0 0 1 0-.5ZM51.881 68.329a.177.177 0 1 0 0-.355.177.177 0 0 0 0 .355ZM58.74 64.822c0-.098.08-.178.176-.178.098 0 .178.08.178.177 0 .098-.08.178-.178.178a.178.178 0 0 1-.177-.177ZM52.608 68.774a.177.177 0 1 0 0-.355.177.177 0 0 0 0 .355ZM53.5 69.01a.177.177 0 1 0 0-.355.177.177 0 0 0 0 .355ZM54.492 69.01a.143.143 0 1 0 0-.287.143.143 0 0 0 0 .286ZM59.094 65.686a.143.143 0 1 1 0 .287.143.143 0 0 1 0-.287ZM55.387 68.798a.143.143 0 1 0 0-.286.143.143 0 0 0 0 .286ZM54.672 60.922c1.521 0 2.648.71 2.648.71-1.353-2.66-2.106-3.489-2.106-3.489-1.754 1.924-2.803 3.105-3.335 3.69.97-.69 1.94-.91 2.791-.91h.002Zm0-.532a5.28 5.28 0 0 0-.835.066c.384-.425.828-.918 1.338-1.48.229.33.562.848.99 1.614-.43-.115-.939-.2-1.492-.2ZM57.204 70.311c-.083 1.682-.95 3.36-.95 3.36-.005-1.326-1.076-2.487-1.045-2.485 1.523.177 1.995-.875 1.995-.875ZM46.875 69.216s.631-.926 1.533-1.064c0 0-.25-2.646-4.949-5.702 0 0 3.814 3.013 3.413 6.766h.003Zm.116-2.867c.073.105.141.202.2.297.308.48.48.874.575 1.144a3.016 3.016 0 0 0-.371.199 6.948 6.948 0 0 0-.406-1.64h.002ZM46.875 64.02c1.015 0 1.532-.999 1.532-.999-.357.71-.517 2.308-.517 2.308-.107-.668-1.015-1.31-1.015-1.31ZM49.33 55.77l-.61.663-.835-.663h-.002.002-.002.002l.836-.66.61.66h.002-.003ZM53.917 55.843v.002l-.625.661-.61-.66.61-.664.625.66ZM24.817 23.006a3.57 3.57 0 0 0-3.564-3.566 3.566 3.566 0 0 0 0 7.13 3.567 3.567 0 0 0 3.564-3.564Zm-.71 0a2.857 2.857 0 0 1-2.854 2.855 2.857 2.857 0 0 1-2.854-2.855 2.857 2.857 0 0 1 2.854-2.854 2.857 2.857 0 0 1 2.855 2.854Z",
    fill: "#EBD692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.177 23.007a1.925 1.925 0 0 0-1.924-1.924 1.925 1.925 0 0 0-1.924 1.924c0 1.061.863 1.924 1.924 1.924a1.925 1.925 0 0 0 1.924-1.924Zm-.71 0a1.215 1.215 0 1 1-2.43-.001 1.215 1.215 0 0 1 2.43 0ZM56.169 26.573a3.567 3.567 0 0 0 3.564-3.564 3.57 3.57 0 0 0-3.564-3.566 3.566 3.566 0 0 0 0 7.13Zm-2.854-3.564a2.857 2.857 0 0 1 2.854-2.855 2.857 2.857 0 0 1 2.854 2.855 2.857 2.857 0 0 1-2.854 2.854 2.857 2.857 0 0 1-2.854-2.854Z",
    fill: "#EBD692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.245 23.007c0 1.061.863 1.924 1.924 1.924a1.925 1.925 0 0 0 1.924-1.924 1.925 1.925 0 0 0-1.924-1.924 1.925 1.925 0 0 0-1.924 1.924Zm.71 0a1.215 1.215 0 1 1 2.43 0 1.215 1.215 0 0 1-2.43 0ZM36.482 26.218c.117-.105-1.064-3.21-1.064-3.21s-8.187 2.041-11.313 5.887c0 0 3.658-1.873 7.548-1.873 1.375 0 2.779.233 4.059.867l.77-1.669v-.002Zm-.729-.114-.393.855c-1.106-.43-2.35-.646-3.707-.646-1.36 0-2.685.213-3.848.502a26.543 26.543 0 0 1 3.393-1.647 38.425 38.425 0 0 1 3.78-1.304c.343.923.67 1.86.773 2.242l.002-.002Z",
    fill: "#EBD692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.313 25.95s1.385-.781 3.277-1.02l.236 1.02s-1.587-.458-3.515 0h.002ZM52.717 28.892c-3.127-3.843-11.313-5.886-11.313-5.886s-1.183 3.105-1.064 3.21l.77 1.668c1.283-.634 2.684-.867 4.06-.867 3.889 0 7.547 1.873 7.547 1.873v.002Zm-3.695-2.08c-1.164-.288-2.49-.502-3.855-.502-1.365 0-2.602.216-3.707.646l-.394-.855c.102-.381.43-1.319.773-2.24 1.312.377 4.506 1.385 7.18 2.952h.003Z",
    fill: "#EBD692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.997 25.95.235-1.02c1.893.236 3.278 1.02 3.278 1.02-1.927-.458-3.516 0-3.516 0h.003ZM38.57 83.344a.575.575 0 1 1-.001-1.15.575.575 0 0 1 0 1.15ZM23.167 82.572a.43.43 0 1 0 0-.86.43.43 0 0 0 0 .86ZM53.662 82.572a.43.43 0 1 0 0-.86.43.43 0 0 0 0 .86ZM49.248 92.294a.43.43 0 1 0 0-.86.43.43 0 0 0 0 .86ZM49.248 20.123a.43.43 0 1 0 0-.86.43.43 0 0 0 0 .86ZM45.004 19.606a.43.43 0 1 1 0-.86.43.43 0 1 1 0 .86ZM32.714 19.606a.43.43 0 1 0 0-.86.43.43 0 0 0 0 .86ZM28.585 92.294a.43.43 0 1 0 0-.86.43.43 0 0 0 0 .86ZM45.004 91.949a.43.43 0 1 1 0 .86.43.43 0 1 1 0-.86ZM32.714 91.966a.43.43 0 1 1 .002.858.43.43 0 0 1-.002-.858ZM28.585 20.123a.43.43 0 1 0 0-.86.43.43 0 0 0 0 .86Z",
    fill: "#EBD692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.079 88.653a5.18 5.18 0 0 0 5.174 5.174 5.179 5.179 0 0 0 4.861-6.95 21.832 21.832 0 0 0 10.502 3.85l.16-.389.036.015 1.696-4.314 1.696 4.314.036-.015.175.413a21.853 21.853 0 0 0 10.822-3.899 5.18 5.18 0 0 0 4.851 6.974 5.179 5.179 0 0 0 5.175-5.174 5.179 5.179 0 0 0-2.985-4.686c.485-1.642 2.387-8.519 2.422-15.702h-.025c-.126-4.837-2.356-9.433-5.196-12.516 2.791-3.03 4.992-7.52 5.186-12.268h.035c-.037-7.3-2-14.284-2.447-15.778a5.18 5.18 0 0 0 3.008-4.698 5.18 5.18 0 0 0-5.175-5.174 5.179 5.179 0 0 0-4.851 6.974 21.829 21.829 0 0 0-10.822-3.899l-.175.413-.037-.014-1.695 4.314-1.696-4.314-.036.014-.16-.389c-3.88.36-7.47 1.733-10.502 3.85a5.18 5.18 0 0 0-4.861-6.95 5.179 5.179 0 0 0-5.175 5.175 5.177 5.177 0 0 0 3.051 4.715c-.398 1.334-1.928 6.792-2.339 12.99a14.153 14.153 0 0 0-.155 2.092h-.01c0 4.86 2.23 9.745 5.05 12.945-2.82 3.199-5.05 8.087-5.05 12.945h.01c0 .593.04 1.174.111 1.747.005.085.015.168.022.252.37 6.222 1.9 11.768 2.337 13.252a5.18 5.18 0 0 0-3.027 4.706l.003.005ZM18.216 76.9a22.024 22.024 0 0 0 4.181 6.707 5.226 5.226 0 0 0-1.144-.129 5.24 5.24 0 0 0-1.482.216 63.219 63.219 0 0 1-1.555-6.794Zm41.665-6.686c-.773 6.863-6.608 12.217-13.675 12.217-2.507 0-4.858-.678-6.887-1.853.256-.178.506-.362.749-.554a12.508 12.508 0 0 0 5.978 1.513c1.965 0 3.826-.447 5.49-1.244a5.772 5.772 0 0 0 2.055-1.236c3.156-2.325 5.206-6.061 5.206-10.271 0-1.108-.204-3.012-.641-4.14l-.09.273a4.224 4.224 0 0 0-4.178-2.884v.015a3.13 3.13 0 0 0-3.032 3.121c0 1.691 1.241 2.96 2.823 3.112.138.024.282.041.427.041a2.43 2.43 0 0 0 2.427-2.426 2.43 2.43 0 0 0-2.427-2.427 2.43 2.43 0 0 0-2.426 2.427v.012a2.419 2.419 0 0 1 2.303-3.153v-.01c.026 0 .053-.005.082-.005a3.513 3.513 0 0 1 3.508 3.508c0 1.933-1.45 3.376-3.277 3.496v-.008a4.84 4.84 0 0 1-5.136-4.513 4.816 4.816 0 0 1 1.3-3.613l.005.01 4.642-5.415-.014-.012.017-.02c2.689 2.819 4.715 7.218 4.853 12.006h-.048c.007.226.012.454.012.683 0 .456-.017.908-.044 1.358l-.002-.008Zm.031-26.729h.042c-.18 4.776-2.23 9.151-4.932 11.935l-4.474-5.218-.005.01a4.812 4.812 0 0 1-1.3-3.613 4.84 4.84 0 0 1 5.136-4.513v-.007a3.51 3.51 0 0 1 3.279 3.495c0 1.856-1.574 3.508-3.508 3.508-.027 0-.053-.002-.082-.005v-.01a2.419 2.419 0 0 1-2.303-3.153v.013a2.43 2.43 0 0 0 2.426 2.426 2.43 2.43 0 0 0 2.427-2.426 2.43 2.43 0 0 0-2.427-2.427c-.145 0-.289.014-.43.041a3.13 3.13 0 0 0-2.822 3.112c0 1.623 1.35 3.07 3.031 3.122v.014a4.223 4.223 0 0 0 4.237-3.073c.4-1.14.588-2.93.588-3.991 0-7.033-5.721-12.754-12.754-12.754-2.162 0-4.197.55-5.978 1.514a13.81 13.81 0 0 0-.748-.554 13.68 13.68 0 0 1 6.887-1.854c6.998 0 12.79 5.252 13.65 12.023a20.954 20.954 0 0 1 .058 2.395l.002-.01ZM38.656 30.491c-.57-.35-1.17-.66-1.79-.933l1.642-2.88 1.703 2.987a14.4 14.4 0 0 0-1.555.826Zm-19.62 12.214c0-3.28 1.318-6.252 3.449-8.427a5.725 5.725 0 0 0-.678 2.709c0 1.746.828 3.36 2.082 4.44a5.073 5.073 0 0 0-.722-.058v-.007a4.222 4.222 0 0 0-4.067 2.582 12.295 12.295 0 0 1-.065-1.239Zm4.046 27.75v-.007a5.87 5.87 0 0 0 .722-.059c-1.251 1.081-2.08 2.694-2.08 4.441 0 .68.12 1.331.335 1.936a11.995 11.995 0 0 1-2.995-8.789 4.223 4.223 0 0 0 3.843 2.483c.059 0 .12 0 .178-.005h-.003Zm7.638 3.058c0-2.37-1.832-4.297-4.084-4.297-.058 0-.116.005-.175.007a5.533 5.533 0 0 0 1.519-6.721c.211-.513.43-.97.65-1.373a2.37 2.37 0 1 0 2.367-2.638c.726-.42 1.239-.41 1.248-.408l.008-.187a6.842 6.842 0 0 0 4.188 4.302 6.837 6.837 0 0 0-4.706 6.496v.034c.008 1.567.267 3.073.736 4.484l-.136.09c.153.481.236.994.236 1.523a5.07 5.07 0 0 1-5.065 5.065c-.651 0-1.27-.124-1.841-.347-.491-.248-.965-.53-1.414-.84a5.058 5.058 0 0 1-1.81-3.878c0-1.963 1.205-3.746 2.842-4.586v-.01a3.153 3.153 0 0 1 1.358-.308c1.861 0 3.374 1.61 3.374 3.587-.007 1.429-1.025 2.6-2.327 2.758.357-.309.583-.763.583-1.27 0-.929-.755-1.684-1.68-1.684a1.678 1.678 0 0 0-1.268 2.784l-.006.007c.022.022.046.041.07.063.08.083.17.158.268.224.498.371 1.11.592 1.776.592.026 0 .05 0 .075-.004v.014c1.78-.063 3.214-1.598 3.221-3.484l-.007.005ZM25.61 75c0-.537.437-.972.972-.972.534 0 .972.438.972.972a.975.975 0 0 1-1.511.809.966.966 0 0 1-.432-.809Zm17.323-6.304v.022c.316 5.296-3.24 8.553-4.283 9.39-1.07-.832-4.766-4.092-4.45-9.39v-.022c0-2.361 1.958-4.28 4.365-4.28a4.4 4.4 0 0 1 3.086 1.253 4.225 4.225 0 0 1 1.263 3.008h.017v.017l.002.002Zm-4.917 9.938c-.242.173-.49.335-.745.489a13.734 13.734 0 0 1-4.827-10.41 6.133 6.133 0 0 1 6.126-6.107c.059.002.12 0 .178 0 3.367 0 6.107 2.733 6.126 6.095-.01 4.2-1.912 7.96-4.892 10.482-.292-.17-.574-.352-.85-.546l.007-.005.082-.068c1.264-1.052 4.74-4.458 4.426-9.863 0-1.377-.57-2.624-1.489-3.527a5.102 5.102 0 0 0-3.602-1.48c-2.799 0-5.075 2.238-5.075 4.99h.017v.017c-.049.845 0 1.642.119 2.39v.066c.039.221.09.442.143.658.163.71.389 1.368.654 1.975l.029.068c.027.063.056.124.085.187a12.827 12.827 0 0 0 3.496 4.596l-.008-.007Zm13.267.991a5.064 5.064 0 0 1-6.453-6.32l-.012-.008c.486-1.436.756-2.97.763-4.567v-.032c0-3.029-1.97-5.596-4.696-6.493a6.862 6.862 0 0 0 3.115-2.281 2.371 2.371 0 1 0 .476-.71c.486-.83.799-1.77.896-2.776 2.235.37 4.247 3.656 4.735 4.514a5.535 5.535 0 0 0 .393 8.269c-2.242.012-4.061 1.933-4.064 4.297.008 1.876 1.424 3.404 3.192 3.481a1.683 1.683 0 0 0 2.143-1.615c0-.926-.756-1.684-1.681-1.684a1.677 1.677 0 0 0-1.581 2.247c-.805-.473-1.354-1.382-1.359-2.429 0-1.977 1.514-3.588 3.375-3.588.485 0 .945.112 1.36.309v.01c1.635.84 2.84 2.623 2.84 4.586 0 1.45-.615 2.76-1.594 3.685-.578.423-1.195.797-1.846 1.113l-.002-.008Zm6.806-10.844c0 3.02-1.12 5.78-2.96 7.895a5.75 5.75 0 0 0 .305-1.848c0-1.733-.814-3.33-2.048-4.412.166.017.333.03.5.032v.007c.06.002.12.005.178.005a4.224 4.224 0 0 0 3.972-2.801c.034.37.053.743.053 1.122Zm-8.97 6.598c0-.537.436-.972.97-.972.535 0 .972.438.972.972a.974.974 0 0 1-.971.972.975.975 0 0 1-.972-.972Zm1.073-24.514c-.493.865-2.539 4.203-4.795 4.524a6.808 6.808 0 0 0-.669-2.626 2.371 2.371 0 1 0-.84-1.81c0 .199.027.393.075.58a6.848 6.848 0 0 0-3.078-2.235 6.836 6.836 0 0 0 4.696-6.493v-.034a14.395 14.395 0 0 0-.707-4.4 5.007 5.007 0 0 1-.197-1.384 5.07 5.07 0 0 1 5.066-5.065 5.07 5.07 0 0 1 5.065 5.065c0 1.963-1.205 3.746-2.843 4.586v.01a3.154 3.154 0 0 1-1.358.309c-1.86 0-3.374-1.611-3.374-3.588.005-1.047.554-1.956 1.358-2.43-.063.178-.1.365-.1.564 0 .928.756 1.68 1.681 1.68.926 0 1.681-.755 1.681-1.68a1.685 1.685 0 0 0-2.142-1.616c-1.769.08-3.185 1.606-3.192 3.482 0 2.363 1.822 4.285 4.064 4.297a5.525 5.525 0 0 0-2.05 3.955 5.538 5.538 0 0 0 1.656 4.314l.003-.005Zm3.782-9.505v.007a4.899 4.899 0 0 0-.5.031c1.234-1.08 2.048-2.681 2.048-4.411 0-.792-.16-1.545-.45-2.233a11.995 11.995 0 0 1 2.96 9.166 4.221 4.221 0 0 0-3.88-2.563c-.059 0-.12 0-.178.005v-.002Zm-13.33-9.404a11.95 11.95 0 0 1 5.403-1.283c1.242 0 2.442.19 3.57.54a5.783 5.783 0 0 0-5.603 5.077 14.572 14.572 0 0 0-3.37-4.334ZM29.414 50.95c0-.916.746-1.661 1.662-1.661.915 0 1.661.745 1.661 1.661s-.746 1.662-1.661 1.662a1.664 1.664 0 0 1-1.662-1.662Zm3.173 1.827c-.146.304-.27.617-.37.943-.19-.022-.595-.107-1.107-.401a2.354 2.354 0 0 0 1.477-.542Zm-6.487.051a1.167 1.167 0 0 1 1.346 1.343 1.156 1.156 0 0 1-.945.946 1.165 1.165 0 0 1-1.346-1.343c.078-.48.467-.868.945-.946Zm-.403 6.518a1.836 1.836 0 0 0 1.395-.075c-.061.09-.122.177-.178.262-.18.265-.33.508-.452.707l-.767-.894h.002Zm24.116-1.705a1.157 1.157 0 0 1 1.144-.962 1.166 1.166 0 0 1 1.146 1.36 1.156 1.156 0 0 1-.945.945 1.164 1.164 0 0 1-1.346-1.343Zm1.34 2.06-.468.546a13.782 13.782 0 0 0-.418-.668 1.778 1.778 0 0 0 .887.121Zm-18.525-3.95c.007-3.311 2.657-6.013 5.95-6.108a6.135 6.135 0 0 1 6.126 6.108 6.135 6.135 0 0 1-6.127 6.107 6.13 6.13 0 0 1-5.95-6.107Zm-7.487 1.826a1.161 1.161 0 1 1 2.322 0 1.161 1.161 0 0 1-2.322 0Zm3.022-3.775c.731.836 1.628 1.635 2.611 2.043-.993.41-1.897 1.222-2.63 2.065a1.87 1.87 0 0 0-1.338-2.133 1.878 1.878 0 0 0 1.342-1.489c.027-.163.03-.325.015-.486Zm22.021-18.338c.537 0 .972.437.972.971a.975.975 0 0 1-.972.972.975.975 0 0 1-.972-.971c0-.535.438-.972.972-.972Zm-3.916 13.83c.916 0 1.662.745 1.662 1.661s-.746 1.662-1.662 1.662a1.664 1.664 0 0 1-1.661-1.662c0-.916.745-1.661 1.661-1.661Zm5.663 5.431a1.163 1.163 0 0 1-2.031-.551 1.163 1.163 0 0 1 2.29-.398c.059.35-.033.685-.26.95Zm-1.242-3.282.581.678a1.888 1.888 0 0 0-1.164.243c.246-.36.443-.678.583-.918v-.002Zm2.226 2.595 1.55 1.807-1.635 1.907a1.856 1.856 0 0 0-.443-1.12 1.89 1.89 0 0 0-1.741-.634 1.874 1.874 0 0 0-1.53 1.53c-.027.161-.03.321-.015.48-.75-.878-1.684-1.735-2.714-2.163 1.093-.452 2.075-1.384 2.845-2.317-.06.245-.073.503-.032.76a1.874 1.874 0 0 0 1.844 1.557c.552 0 1.071-.24 1.426-.66.275-.324.428-.73.442-1.15l.003.003Zm-6.73 5.165c.916 0 1.662.745 1.662 1.661s-.746 1.662-1.661 1.662a1.664 1.664 0 0 1-1.662-1.662c0-.916.746-1.661 1.662-1.661Zm2.537 21.324c-.858.194-1.75.3-2.668.3a11.98 11.98 0 0 1-5.402-1.282 14.63 14.63 0 0 0 3.272-4.142 5.787 5.787 0 0 0 4.798 5.124Zm-12.1-1.035a11.974 11.974 0 0 1-8.219 1.044 5.783 5.783 0 0 0 4.873-5.393 14.476 14.476 0 0 0 3.346 4.349Zm-5.627-20.29c.916 0 1.662.746 1.662 1.662 0 .916-.746 1.662-1.662 1.662a1.664 1.664 0 0 1-1.661-1.662c0-.916.746-1.661 1.661-1.661Zm-4.112 1.757c.082-.15.3-.535.624-1.023.938-1.392 2.64-3.483 4.443-3.532.032.335.087.66.163.979-.625.053-2.833.522-4.57 4.36a5.68 5.68 0 0 0-.66-.784Zm-4.188-5.114 1.744-2.033a1.856 1.856 0 0 0 1.365 1.965 1.873 1.873 0 0 0-1.346 2.128l-1.766-2.06h.003Zm3.163-3.69.61-.712c.123.21.29.482.492.785a1.898 1.898 0 0 0-.976-.097c-.044.007-.085.017-.129.027l.003-.003Zm1.098-1.29a5.64 5.64 0 0 0 .67-.792c1.618 3.576 3.646 4.227 4.419 4.344a7.002 7.002 0 0 0-.122.991c-2.322-.165-4.462-3.654-4.968-4.54v-.003Zm1.656-4.314a5.538 5.538 0 0 0-2.06-3.962c.059.002.117.007.175.007 2.252 0 4.084-1.929 4.084-4.297-.008-1.885-1.438-3.42-3.221-3.484v.015c-.025 0-.051-.005-.076-.005-.665 0-1.28.223-1.776.593-.097.065-.187.14-.267.223-.022.022-.046.041-.07.063l.005.008c-.258.296-.413.68-.413 1.1a1.683 1.683 0 0 0 3.364 0c0-.508-.226-.962-.583-1.27 1.305.157 2.323 1.328 2.327 2.757 0 1.977-1.513 3.588-3.374 3.588-.483 0-.945-.112-1.36-.309v-.01c-1.635-.84-2.84-2.623-2.84-4.586a5.07 5.07 0 0 1 5.065-5.065 5.07 5.07 0 0 1 4.929 6.233c-.498 1.45-.773 3-.78 4.616v.034a6.84 6.84 0 0 0 4.706 6.496 6.843 6.843 0 0 0-3.069 2.215 2.371 2.371 0 1 0-4.654-.836c-.224-.4-.442-.854-.651-1.367.403-.83.605-1.773.542-2.76l-.003.003Zm-.964-9.737a.973.973 0 0 1-1.944 0 .965.965 0 0 1 .435-.809.973.973 0 0 1 1.511.809h-.002Zm-.173-5.602a12.002 12.002 0 0 1 3.613-.553c1.994 0 3.872.488 5.531 1.35a14.567 14.567 0 0 0-3.299 4.259 5.781 5.781 0 0 0-5.728-5.058c-.039 0-.078 0-.117.002Zm9.802 1.164c.255.153.503.318.746.488a12.801 12.801 0 0 0-3.495 4.597c-.03.06-.056.123-.086.187l-.029.068c-.267.607-.49 1.265-.653 1.975-.054.218-.102.437-.146.658v.066c-.117.745-.165 1.542-.117 2.39 0 2.752 2.277 4.99 5.075 4.99 2.799 0 5.075-2.238 5.075-4.99.31-5.405-3.163-8.811-4.426-9.863-.027-.024-.056-.046-.083-.068l-.007-.005c.274-.194.559-.376.85-.546a13.793 13.793 0 0 1 4.205 6.224c.034.119.07.235.11.35.371 1.238.575 2.55.578 3.908a6.134 6.134 0 0 1-6.127 6.095l-.177-.002a6.13 6.13 0 0 1-6.127-6.105c.005-1.343.207-2.64.571-3.87l.01.01c.065-.185.121-.374.17-.566a13.811 13.811 0 0 1 4.079-5.984l.005-.007Zm5.665 10.427c0 2.36-1.958 4.28-4.365 4.28s-4.365-1.92-4.365-4.28v-.022c-.316-5.298 3.379-8.561 4.45-9.39 1.042.836 4.599 4.096 4.285 9.39v.022h-.005Zm-5.1-10.886c.266-.207.54-.4.823-.588.257.17.507.345.75.53-.286.177-.566.366-.835.568-.24-.18-.486-.35-.739-.512v.002Zm16.008 12.324c.075-.008.15-.013.226-.013v-.019c.041-.002.082-.007.126-.007.948 0 1.718.77 1.718 1.717a1.719 1.719 0 0 1-3.435 0c0-.826.588-1.518 1.367-1.68l-.002.002Zm-.085 23.328a1.721 1.721 0 0 1-1.368-1.681 1.719 1.719 0 0 1 3.435 0c0 .947-.77 1.717-1.717 1.717-.042 0-.083-.002-.127-.007v-.02c-.075 0-.15-.004-.226-.011l.003.002Zm-15.1 12.596a13.017 13.017 0 0 1-.824-.588c.253-.16.498-.333.739-.513.27.2.549.389.835.569-.245.184-.495.362-.75.53v.002Zm-.664.408a13.685 13.685 0 0 1-6.887 1.853c-6.979 0-12.756-5.223-13.642-11.964a44.173 44.173 0 0 1-.068-2.206v-.085h-.056c.124-4.686 1.9-8.888 4.662-11.816l4.506 5.255.005-.01a4.812 4.812 0 0 1 1.3 3.613 4.84 4.84 0 0 1-5.136 4.513v.007a3.51 3.51 0 0 1-3.28-3.495c0-1.856 1.575-3.508 3.508-3.508.027 0 .054.002.083.005v.01a2.419 2.419 0 0 1 2.393 2.742 2.43 2.43 0 0 0-2.4-2.09 2.43 2.43 0 0 0-2.427 2.428v.01h-.003a2.45 2.45 0 0 0 2.44 2.448v.005a3.129 3.129 0 0 0 3.126-3.126c0-1.725-1.351-3.071-3.032-3.122v-.015a4.222 4.222 0 0 0-4.1 2.67l-.015-.041c-.438 1.127-.642 3.03-.642 4.14 0 4.323 2.165 8.147 5.464 10.455.474.396 1.01.719 1.593.95a12.674 12.674 0 0 0 5.697 1.348c2.213 0 4.29-.573 6.098-1.58.264.212.537.416.816.608L38 80.573ZM21.268 65.827c0-.947.77-1.717 1.717-1.717.948 0 1.718.77 1.718 1.717a1.719 1.719 0 0 1-3.435 0Zm.86-10.567c-2.797-2.898-4.614-7.089-4.774-11.777h.049c.005-.897.039-1.788.094-2.665.98-6.64 6.71-11.75 13.614-11.75 2.507 0 4.858.677 6.887 1.853-.28.192-.551.396-.816.607a12.51 12.51 0 0 0-6.098-1.579c-7.032 0-12.753 5.721-12.753 12.754 0 1.108.204 3.012.64 4.14a4.224 4.224 0 0 0 4.021 2.946c.059 0 .12 0 .178-.005v-.014a3.13 3.13 0 0 0 3.031-3.122c0-1.69-1.401-3.126-3.126-3.126v.005a2.454 2.454 0 0 0-2.439 2.448h.002v.01a2.43 2.43 0 0 0 2.427 2.427c1.225 0 2.235-.911 2.4-2.09.015.107.025.214.025.326a2.419 2.419 0 0 1-2.417 2.417v.01c-.027 0-.054.005-.083.005a3.513 3.513 0 0 1-3.508-3.508c0-1.934 1.45-3.377 3.277-3.496v.008a4.84 4.84 0 0 1 5.136 4.513 4.812 4.812 0 0 1-1.3 3.612l-.005-.01-4.329 5.051-.058-.075-.083.087.008-.002Zm2.66-9.28a1.719 1.719 0 0 1-3.435 0c0-.947.77-1.717 1.717-1.717.947 0 1.718.77 1.718 1.717ZM19.8 27.967a5.155 5.155 0 0 0 2.602.083 21.985 21.985 0 0 0-4.152 6.639 62.755 62.755 0 0 1 1.553-6.72l-.003-.002Zm4.861-2.08c-.333.277-.658.564-.974.86-.7.457-1.533.722-2.43.722a4.47 4.47 0 0 1-4.464-4.465 4.468 4.468 0 0 1 4.465-4.465 4.468 4.468 0 0 1 4.465 4.465 4.445 4.445 0 0 1-1.06 2.884h-.002Zm13.313.3-1.766 3.1a14.429 14.429 0 0 0-5.097-.929c-5.225 0-9.812 2.784-12.358 6.945a21.342 21.342 0 0 1 5.296-7.948 5.186 5.186 0 0 0 1.161-1.023 21.176 21.176 0 0 1 10.985-4.657l1.774 4.511h.005Zm14.23.228c.294.335.632.634 1.004.884a21.332 21.332 0 0 1 5.354 7.995c-2.546-4.157-7.13-6.936-12.35-6.936a14.37 14.37 0 0 0-5.68 1.164l.318-.18-1.795-3.153 1.785-4.543c4.293.44 8.211 2.16 11.364 4.771v-.002Zm3.887 1.054a4.427 4.427 0 0 1-2.519-.782 20.634 20.634 0 0 0-.811-.714 4.441 4.441 0 0 1-1.132-2.966 4.47 4.47 0 0 1 4.465-4.466 4.468 4.468 0 0 1 4.465 4.465 4.468 4.468 0 0 1-4.465 4.465l-.003-.002Zm1.501.486a63.28 63.28 0 0 1 1.616 7.076 21.956 21.956 0 0 0-4.295-6.991c.379.087.772.136 1.178.136.522 0 1.025-.078 1.501-.223v.002Zm.025 55.75a5.175 5.175 0 0 0-2.704-.093 22.016 22.016 0 0 0 4.322-7.06 63.254 63.254 0 0 1-1.618 7.152Zm-4.856 1.977c.276-.231.546-.47.811-.715a4.436 4.436 0 0 1 2.522-.782 4.47 4.47 0 0 1 4.465 4.465 4.468 4.468 0 0 1-4.465 4.465 4.468 4.468 0 0 1-4.465-4.465c0-1.14.43-2.179 1.132-2.969Zm-13.706-.214 1.795-3.153-.617-.353-1.718 3.017-1.715-3.01c.647-.276 1.268-.6 1.864-.964a14.38 14.38 0 0 0 7.55 2.13c5.332 0 9.996-2.9 12.508-7.205a21.331 21.331 0 0 1-5.512 8.425c-.372.25-.71.55-1.003.884a21.185 21.185 0 0 1-11.364 4.771l-1.786-4.542h-.002Zm-13.837-.146a5.241 5.241 0 0 0-1.162-1.023 21.3 21.3 0 0 1-5.453-8.378c2.51 4.31 7.178 7.217 12.515 7.217 1.99 0 3.885-.403 5.612-1.132l-.544.311 1.795 3.153-1.773 4.511a21.174 21.174 0 0 1-10.985-4.657l-.005-.002Zm-8.423 3.328a4.47 4.47 0 0 1 4.465-4.465c.897 0 1.73.265 2.43.722.315.296.64.583.974.86a4.44 4.44 0 0 1 1.059 2.883 4.47 4.47 0 0 1-4.465 4.465 4.468 4.468 0 0 1-4.465-4.465h.002Z",
    fill: "#EBD692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.687 88.653a3.567 3.567 0 0 0 3.563 3.563 3.567 3.567 0 0 0 3.564-3.563 3.57 3.57 0 0 0-3.564-3.567 3.568 3.568 0 0 0-3.563 3.567Zm.71 0a2.857 2.857 0 0 1 2.854-2.855 2.857 2.857 0 0 1 2.854 2.855 2.857 2.857 0 0 1-2.855 2.854 2.857 2.857 0 0 1-2.854-2.854Z",
    fill: "#EBD692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.33 88.653c0 1.061.862 1.923 1.923 1.923a1.925 1.925 0 0 0 1.924-1.923 1.925 1.925 0 0 0-1.924-1.925 1.925 1.925 0 0 0-1.924 1.925Zm.709 0a1.215 1.215 0 1 1 2.43 0 1.215 1.215 0 0 1-2.43 0ZM18.008 57.592a1.925 1.925 0 0 0 1.924-1.924 1.925 1.925 0 0 0-1.924-1.924 1.925 1.925 0 0 0-1.924 1.924c0 1.062.862 1.924 1.924 1.924Zm-1.215-1.924a1.215 1.215 0 1 1 2.43.001 1.215 1.215 0 0 1-2.43 0ZM26.66 91.864c0 1.061.863 1.924 1.924 1.924a1.925 1.925 0 0 0 1.925-1.924 1.925 1.925 0 0 0-1.925-1.924 1.925 1.925 0 0 0-1.923 1.924Zm.71 0a1.215 1.215 0 1 1 2.43 0 1.215 1.215 0 0 1-2.43 0ZM47.324 91.864c0 1.061.863 1.924 1.924 1.924a1.925 1.925 0 0 0 1.924-1.924 1.925 1.925 0 0 0-1.924-1.924 1.925 1.925 0 0 0-1.924 1.924Zm.71 0a1.215 1.215 0 1 1 2.43 0 1.215 1.215 0 0 1-2.43 0ZM43.54 92.379c0 .809.658 1.465 1.465 1.465.806 0 1.464-.658 1.464-1.465 0-.806-.658-1.465-1.465-1.465-.806 0-1.464.659-1.464 1.465Zm.532 0a.933.933 0 1 1 1.866 0 .933.933 0 0 1-1.866 0ZM31.25 92.379c0 .809.658 1.465 1.464 1.465.807 0 1.465-.658 1.465-1.465 0-.806-.658-1.465-1.465-1.465-.806 0-1.465.659-1.465 1.465Zm.531 0a.933.933 0 1 1 1.866 0 .933.933 0 0 1-1.866 0ZM30.511 19.693a1.925 1.925 0 1 0-1.924 1.924 1.925 1.925 0 0 0 1.924-1.924Zm-.709 0a1.215 1.215 0 1 1-2.43-.001 1.215 1.215 0 0 1 2.43 0ZM51.172 19.693a1.925 1.925 0 0 0-1.924-1.924 1.925 1.925 0 0 0-1.924 1.924c0 1.061.863 1.924 1.924 1.924a1.925 1.925 0 0 0 1.924-1.924Zm-.71 0a1.215 1.215 0 1 1-2.43-.001 1.215 1.215 0 0 1 2.43 0ZM46.47 19.176c0-.81-.659-1.465-1.465-1.465-.807 0-1.465.658-1.465 1.465 0 .806.658 1.465 1.465 1.465.806 0 1.464-.659 1.464-1.465Zm-.533 0a.933.933 0 1 1-1.866 0 .933.933 0 0 1 1.866 0ZM34.179 19.176c0-.81-.658-1.465-1.465-1.465-.806 0-1.465.658-1.465 1.465 0 .806.659 1.465 1.465 1.465.807 0 1.465-.659 1.465-1.465Zm-.532 0a.933.933 0 1 1-1.866 0 .933.933 0 0 1 1.866 0ZM60.925 55.668a1.925 1.925 0 0 0-1.923-1.924 1.925 1.925 0 0 0-1.925 1.924 1.925 1.925 0 0 0 3.848 0Zm-.709 0a1.215 1.215 0 1 1-2.43 0 1.215 1.215 0 0 1 2.43 0ZM52.605 88.653a3.567 3.567 0 0 0 3.564 3.563 3.567 3.567 0 0 0 3.564-3.563 3.57 3.57 0 0 0-3.564-3.567 3.568 3.568 0 0 0-3.564 3.567Zm.71 0a2.857 2.857 0 0 1 2.854-2.855 2.857 2.857 0 0 1 2.854 2.855 2.857 2.857 0 0 1-2.854 2.854 2.857 2.857 0 0 1-2.854-2.854Z",
    fill: "#EBD692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.245 88.653c0 1.061.863 1.923 1.924 1.923a1.925 1.925 0 0 0 1.924-1.923 1.925 1.925 0 0 0-1.924-1.925 1.925 1.925 0 0 0-1.924 1.925Zm.71 0a1.215 1.215 0 1 1 2.43 0 1.215 1.215 0 0 1-2.43 0ZM35.418 88.653s1.183-3.105 1.064-3.21l-.77-1.668c-1.283.634-2.684.867-4.06.867-3.889 0-7.547-1.873-7.547-1.873 3.126 3.843 11.313 5.886 11.313 5.886v-.002ZM27.8 84.846c1.163.29 2.49.503 3.855.503 1.365 0 2.602-.216 3.707-.646l.394.855c-.102.381-.43 1.319-.773 2.24-1.312-.377-4.506-1.385-7.18-2.952H27.8Z",
    fill: "#EBD692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.825 85.71-.235 1.021c-1.893-.236-3.277-1.02-3.277-1.02 1.926.459 3.515 0 3.515 0h-.003ZM41.11 83.775l-.77 1.668c-.117.105 1.064 3.21 1.064 3.21s8.186-2.041 11.313-5.887c0 0-3.659 1.873-7.548 1.873-1.375 0-2.779-.233-4.06-.867v.002Zm-.041 1.783.393-.856c1.105.43 2.35.647 3.707.647 1.358 0 2.69-.217 3.855-.503-2.674 1.567-5.869 2.575-7.18 2.951-.343-.92-.671-1.858-.773-2.24h-.002Z",
    fill: "#EBD692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.51 85.71s-1.385.783-3.278 1.021l-.235-1.02s1.586.459 3.515 0h-.003ZM34.826 32.209s-1.125.823-1.218 1.768c0 0-.607-1.535-1.705-2.128 0 0 1.504-.287 2.923.36ZM45.43 31.849c-1.099.59-1.706 2.128-1.706 2.128-.092-.945-1.217-1.768-1.217-1.768 1.419-.647 2.922-.36 2.922-.36ZM33.608 77.645c.093.946 1.218 1.769 1.218 1.769-1.42.646-2.923.36-2.923.36 1.098-.59 1.706-2.129 1.706-2.129ZM42.507 79.414s1.125-.823 1.217-1.769c0 0 .607 1.536 1.705 2.129 0 0-1.504.286-2.922-.36ZM16.691 49.92l1.555 2.947H16.69V49.92ZM16.691 61.561v-2.947h1.555l-1.555 2.947ZM60.571 49.92v2.947h-1.555l1.555-2.947ZM60.571 61.561l-1.555-2.947h1.555v2.947ZM38.545 22.416l-.027-.175-.027.175-.675-2.723-2.167-1h2.85v-.003h2.89l-2.167 1.003-.677 2.723ZM38.491 89.496l.027.174.027-.174.677 2.723 2.167 1.003h-5.74l2.167-1.003.675-2.723Z",
    fill: "#EBD692"
  }))), _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cba",
    x: 0.214,
    y: 0.879,
    width: 77.184,
    height: 109.829,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.393
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_79_4430"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_79_4430",
    result: "shape"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 111,
    fill: "none",
    viewBox: "0 0 78 111",
    id: "card_simple_omaha_back_(1)",
    x: 78,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".caB{fill:#ebd692}")), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#caA)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.322 101.921h48.967a5.322 5.322 0 0 0 5.322-5.322V14.987a5.322 5.322 0 0 0-5.322-5.322H14.322A5.322 5.322 0 0 0 9 14.987v81.611a5.322 5.322 0 0 0 5.323 5.322z",
    fill: "#2d2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.779 96.161h41.987a3.727 3.727 0 0 0 3.727-3.727v-73.33a3.727 3.727 0 0 0-3.727-3.727H17.779a3.726 3.726 0 0 0-3.726 3.727v73.33a3.727 3.727 0 0 0 3.726 3.727z",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.801 16.935h41.805a2.3 2.3 0 0 1 2.296 2.296v73.08a2.3 2.3 0 0 1-2.296 2.296H17.801a2.3 2.3 0 0 1-2.296-2.296v-73.08a2.3 2.3 0 0 1 2.296-2.296zm0-.729a3.032 3.032 0 0 0-3.024 3.024v73.08a3.032 3.032 0 0 0 3.024 3.024h41.805a3.032 3.032 0 0 0 3.024-3.024V19.23a3.032 3.032 0 0 0-3.024-3.024H17.801z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.472 55.77a3.257 3.257 0 1 0 6.516 0 3.257 3.257 0 1 0-6.516 0zm.532 0a2.73 2.73 0 0 1 2.726-2.726 2.73 2.73 0 0 1 2.726 2.726 2.73 2.73 0 0 1-2.726 2.726 2.73 2.73 0 0 1-2.726-2.726z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.922 55.77a1.81 1.81 0 0 0 1.807 1.807 1.81 1.81 0 0 0 1.807-1.807 1.81 1.81 0 0 0-1.807-1.807 1.81 1.81 0 0 0-1.807 1.807zm.709 0a1.1 1.1 0 0 1 1.098-1.098 1.1 1.1 0 0 1 1.098 1.098 1.1 1.1 0 0 1-1.098 1.098 1.1 1.1 0 0 1-1.098-1.098zM30.154 50.953a.917.917 0 0 0 1.832 0 .917.917 0 0 0-1.832 0zm.532 0a.385.385 0 1 1 .77.001.385.385 0 0 1-.77-.001z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.786 55.77a4.943 4.943 0 1 0 9.888 0c0-2.731-2.213-4.943-4.944-4.943s-4.943 2.213-4.943 4.943zm.709 0a4.24 4.24 0 0 1 4.234-4.234 4.24 4.24 0 0 1 4.234 4.234 4.24 4.24 0 0 1-4.234 4.234 4.24 4.24 0 0 1-4.234-4.234zM24.188 45.985c0-.62-.505-1.125-1.125-1.125s-1.125.505-1.125 1.125.505 1.125 1.125 1.125 1.125-.505 1.125-1.125zm-.532 0a.59.59 0 1 1-1.185 0 .59.59 0 1 1 1.185 0zM54.194 44.8c-.619 0-1.125.505-1.125 1.125s.505 1.125 1.125 1.125 1.125-.505 1.125-1.125-.505-1.125-1.125-1.125zm0 .532a.59.59 0 1 1 0 1.186.59.59 0 1 1 0-1.186zM41.871 42.492c.015-.139.275-3.16-3.015-7.686l-.287-.396-.287.396c-3.292 4.528-3.199 7.54-3.194 7.667h.027a3.377 3.377 0 0 0 6.756.022v-.002zm-.707-.071.347.034h-.347c0 1.472-1.198 2.67-2.67 2.67s-2.67-1.198-2.67-2.67h-.381l.355-.014c0-.027-.066-2.735 2.772-6.817 2.818 4.069 2.599 6.768 2.597 6.795l-.002.002z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.077 42.421a1.687 1.687 0 1 0-3.374.002 1.687 1.687 0 0 0 3.374-.002zm-.532 0a1.155 1.155 0 0 1-2.308 0 1.154 1.154 0 0 1 2.308 0z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caB",
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.569 28.317a.576.576 0 1 1 0 1.152.576.576 0 0 1 0-1.152zM26.87 53.972a.576.576 0 1 1-1.152 0 .576.576 0 0 1 1.152 0zM38.569 38.282a.413.413 0 1 1 0-.826.413.413 0 0 1 0 .826z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caC",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caD",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caC",
    x: 6.987,
    y: 8.288,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caC",
    x: 31.552,
    y: 8.544,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.392 42.674a.255.255 0 1 1 0-.51.255.255 0 0 1 0 .51zM36.706 68.951a1.687 1.687 0 1 0 3.37-.002 1.687 1.687 0 0 0-3.37.002zm.532 0a1.155 1.155 0 0 1 2.308 0 1.154 1.154 0 0 1-2.308 0zM38.569 71.303a.576.576 0 1 1 .001 1.151.576.576 0 0 1-.001-1.151z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caE",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caE",
    x: 0.177,
    y: -17.773,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caD",
    x: 19.617,
    y: 20.807,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.549 47.794a.35.35 0 0 1 .35-.35.35.35 0 0 1 .35.35.35.35 0 0 1-.35.35.35.35 0 0 1-.35-.35zM26.372 48.587a.35.35 0 0 1 .35.35.35.35 0 0 1-.35.35.348.348 0 0 1-.35-.35.35.35 0 0 1 .35-.35z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caF",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caF",
    x: -5.848,
    y: -8.896,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caF",
    x: -11.972,
    y: -8.896,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.342 29.947a.43.43 0 0 1-.43-.43.43.43 0 0 1 .86 0 .43.43 0 0 1-.43.43zM17.043 81.761a.43.43 0 0 1 .43.43.43.43 0 1 1-.86 0 .43.43 0 0 1 .43-.43zM59.912 82.191a.43.43 0 0 1 .86 0 .43.43 0 1 1-.86 0z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caF",
    x: 24.647,
    y: -8.896,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.997 38.925a.764.764 0 0 1 0 1.526.764.764 0 0 1 0-1.526z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caG",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caH",
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.178 37.689a.433.433 0 1 1-.866-.002.433.433 0 0 1 .866.002z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caI",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caI",
    x: 0.892,
    y: -1.594,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caJ",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caI",
    x: 4.074,
    y: -2.716,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caI",
    x: 5.651,
    y: -2.282,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caJ",
    x: 4.433,
    y: 1.705,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caK",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caC",
    x: 7.669,
    y: -2.551,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caC",
    x: 7.414,
    y: -3.717,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.204 44.824a.25.25 0 1 1 0-.5.25.25 0 1 1 0 .5z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caL",
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.328 46.816c.097 0 .177.08.177.177s-.08.177-.177.177-.177-.08-.177-.177.08-.177.177-.177z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caL",
    x: -0.726,
    y: -0.445,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caL",
    x: -1.617,
    y: -0.68,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caM",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caN",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caM",
    x: -0.894,
    y: 0.211,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.871 69.009a3.37 3.37 0 0 0-.996-2.359 3.372 3.372 0 0 0-2.398-1.001 3.383 3.383 0 0 0-3.379 3.379h.019v.005h-.027c-.005.124-.097 3.139 3.194 7.667l.287.396.287-.396c3.289-4.528 3.029-7.548 3.015-7.686l-.002-.005zm-6.073.049-.355-.015h.381a2.673 2.673 0 0 1 2.67-2.67c.731 0 1.397.296 1.88.775.476.483.773 1.144.773 1.875h.017l.347.017-.347.034c.002.027.221 2.728-2.597 6.795-2.837-4.081-2.772-6.79-2.772-6.817l.002.005zM22.572 50.892c-1.521 0-2.648-.709-2.648-.709 1.353 2.66 2.106 3.489 2.106 3.489l3.335-3.69c-.969.69-1.941.911-2.791.911h-.003zm-1.491.333c.43.114.938.199 1.491.199a5.29 5.29 0 0 0 .836-.066l-1.338 1.479c-.228-.33-.561-.848-.989-1.613zM20.041 41.503c.083-1.681.95-3.36.95-3.36.005 1.326 1.076 2.488 1.045 2.485-1.523-.177-1.994.875-1.994.875zM28.837 43.662s.25 2.645 4.948 5.702c0 0-3.814-3.012-3.413-6.766 0 0-.632.925-1.533 1.064h-.002zm1.013.163a6.79 6.79 0 0 0 .398 1.623c-.43-.61-.653-1.103-.768-1.423.131-.058.255-.126.369-.199zM30.37 47.795c-1.015 0-1.533.999-1.533.999.357-.709.517-2.308.517-2.308.107.668 1.015 1.309 1.015 1.309zM29.445 55.77l-.838.663-.61-.663.61-.661.838.661zM24.647 55.845l-.61.661-.624-.661h-.003l.003-.002.624-.661.61.663z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caO",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caB",
    x: 12.467,
    y: 14.481,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caC",
    x: 38.713,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caC",
    x: 39.248,
    y: -1.145,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caP",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caQ",
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.313 38.843a.43.43 0 0 0 .43-.43.43.43 0 0 0-.43-.43.43.43 0 0 0-.43.43.43.43 0 0 0 .43.43zM49.333 40.451a.764.764 0 1 1 .763-.763.764.764 0 0 1-.763.763z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caR",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caH",
    x: 28.056,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caS",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caI",
    x: 29.484,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caI",
    x: 28.593,
    y: -1.594,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caI",
    x: 27.033,
    y: -2.459,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.333 33.72a.433.433 0 1 0 0-.866.433.433 0 0 0 0 .866z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caI",
    x: 23.834,
    y: -2.282,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caK",
    x: 14.969,
    y: -1.924,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.774 37.607a.433.433 0 1 1 .002-.866.433.433 0 0 1-.002.866z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caC",
    x: 31.046,
    y: -2.551,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caC",
    x: 31.299,
    y: -3.717,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.126 44.324a.25.25 0 1 1 0 .5.25.25 0 1 1 0-.5z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caL",
    x: 26.603,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.177 46.993c0 .097-.08.177-.177.177s-.177-.08-.177-.177.08-.177.177-.177.177.08.177.177z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caL",
    x: 27.33,
    y: -0.445,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caL",
    x: 28.221,
    y: -0.68,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caN",
    x: 36.427,
    y: -3.037,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caT",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caM",
    x: 32.718,
    y: 0.211,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.302 53.671s.753-.828 2.106-3.489c0 0-1.127.709-2.648.709-.85 0-1.822-.221-2.791-.911l3.335 3.69h-.002zm.947-2.449-.989 1.613-1.338-1.479a5.29 5.29 0 0 0 .836.066c.554 0 1.062-.085 1.492-.199zM57.286 41.503s-.474-1.052-1.994-.875c-.029.002 1.042-1.159 1.045-2.485 0 0 .867 1.681.95 3.36zM48.49 43.662c-.901-.136-1.533-1.064-1.533-1.064.398 3.753-3.413 6.766-3.413 6.766 4.696-3.059 4.948-5.702 4.948-5.702h-.002zm-1.411 1.785a6.79 6.79 0 0 0 .398-1.623 2.82 2.82 0 0 0 .369.199c-.114.321-.338.814-.768 1.426v-.002zM46.957 47.795s.909-.644 1.015-1.309c0 0 .16 1.598.517 2.308 0 0-.517-.998-1.533-.998zM30.988 59.946a.917.917 0 0 0 0 1.832.917.917 0 0 0 0-1.832zm0 .532a.385.385 0 1 1-.001.77.385.385 0 0 1 .001-.77zM21.856 65.83c0 .619.505 1.125 1.125 1.125s1.125-.505 1.125-1.125-.505-1.125-1.125-1.125-1.125.505-1.125 1.125zm.532 0a.59.59 0 1 1 1.186 0 .59.59 0 1 1-1.186 0zM52.984 65.89c0 .619.505 1.125 1.125 1.125s1.125-.505 1.125-1.125-.505-1.125-1.125-1.125-1.125.505-1.125 1.125zm.532 0a.59.59 0 1 1 1.185 0 .59.59 0 1 1-1.185 0z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caC",
    x: -0.085,
    y: 13.239,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caC",
    x: -0.617,
    y: 14.381,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caQ",
    x: -24.14,
    y: 15.081,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caP",
    x: -24.14,
    y: 15.083,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caF",
    x: -0.083,
    y: 34.989,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.912 71.364c.42 0 .763.343.763.763s-.343.763-.763.763-.763-.343-.763-.763.342-.763.763-.763z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caG",
    x: -0.082,
    y: 30.912,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.552 72.86a.434.434 0 1 1 0-.87.434.434 0 1 1 0 .87z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caJ",
    x: -2.711,
    y: 40.581,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caI",
    x: -0.085,
    y: 39.808,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caI",
    x: 0.806,
    y: 41.402,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.289 78.705a.433.433 0 1 1 .002-.866.433.433 0 0 1-.002.866zM27.912 78.96a.433.433 0 1 1 0-.862.433.433 0 0 1 0 .862z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caJ",
    x: 3.116,
    y: 44.551,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caI",
    x: 6.797,
    y: 40.561,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caS",
    x: -22.113,
    y: 36.951,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caC",
    x: 7.585,
    y: 15.787,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caD",
    x: 7.864,
    y: 18.098,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.37 67.241a.25.25 0 1 1-.5 0 .25.25 0 1 1 .5 0z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caL",
    x: -0.085,
    y: 24.489,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caL",
    x: -7.117,
    y: 21.159,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caL",
    x: -0.811,
    y: 24.934,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caL",
    x: -1.702,
    y: 25.17,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caT",
    x: -36.51,
    y: 22.88,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.209 65.83a.143.143 0 1 1-.286 0 .143.143 0 0 1 .286 0z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caM",
    x: -0.976,
    y: 25.706,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.943 58.143s-.753.828-2.106 3.488c0 0 1.127-.709 2.648-.709.85 0 1.822.221 2.791.911l-3.335-3.69h.002zm-.947 2.449.989-1.613 1.338 1.479a5.29 5.29 0 0 0-.836-.066c-.554 0-1.062.085-1.492.199zM19.958 70.312s.474 1.052 1.994.875c.029-.002-1.042 1.159-1.045 2.485 0 0-.867-1.681-.95-3.36zM33.701 62.45c-4.696 3.058-4.948 5.701-4.948 5.701.901.136 1.533 1.064 1.533 1.064-.398-3.753 3.413-6.766 3.413-6.766h.002zm-3.537 3.916a6.79 6.79 0 0 0-.398 1.623 2.82 2.82 0 0 0-.369-.199c.114-.321.338-.814.768-1.426v.002zM29.272 65.329s-.16-1.598-.518-2.308c0 0 .518.999 1.533.999 0 0-.909.644-1.015 1.309z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caO",
    x: -0.083,
    y: 9.909,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caC",
    x: 38.63,
    y: 13.239,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caC",
    x: 39.163,
    y: 14.381,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.696 64.02a.35.35 0 0 1-.35.35.35.35 0 0 1-.35-.35.35.35 0 0 1 .35-.35.35.35 0 0 1 .35.35zM50.873 63.228a.35.35 0 0 1-.35-.35.35.35 0 0 1 .35-.35.35.35 0 0 1 .35.35c0 .194-.155.35-.35.35zM48.66 73.402a.43.43 0 1 1-.86 0 .43.43 0 1 1 .86 0zM49.248 72.889c-.42 0-.763-.343-.763-.763s.343-.763.763-.763.763.343.763.763-.343.763-.763.763z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caR",
    x: -0.083,
    y: 30.912,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.608 72.86a.435.435 0 1 1 0-.87.435.435 0 0 1 0 .87z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caK",
    x: 21.944,
    y: 36.952,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caI",
    x: 29.399,
    y: 39.808,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caI",
    x: 28.507,
    y: 41.402,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caS",
    x: -2.711,
    y: 40.581,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caJ",
    x: 22.876,
    y: 44.983,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caI",
    x: 23.749,
    y: 42.089,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caI",
    x: 22.517,
    y: 40.561,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caI",
    x: 21.766,
    y: 38.637,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caC",
    x: 30.961,
    y: 15.787,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caD",
    x: 31.749,
    y: 18.098,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.041 66.991a.25.25 0 1 1 0 .501.25.25 0 1 1 0-.501z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caL",
    x: 26.518,
    y: 24.489,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.739 64.822c0-.097.08-.177.177-.177s.177.08.177.177-.08.177-.177.177-.177-.08-.177-.177z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caL",
    x: 27.245,
    y: 24.934,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caL",
    x: 28.136,
    y: 25.17,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caM",
    x: 31.741,
    y: 25.917,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caN",
    x: 40.943,
    y: 19.844,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caM",
    x: 32.635,
    y: 25.706,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.673 60.922a5.44 5.44 0 0 1 2.648.709c-1.353-2.66-2.106-3.488-2.106-3.488l-3.335 3.69c.969-.69 1.941-.911 2.791-.911h.002zm0-.532a5.28 5.28 0 0 0-.836.066l1.339-1.479c.228.33.561.848.989 1.613a5.844 5.844 0 0 0-1.492-.199zM57.204 70.312c-.083 1.681-.95 3.36-.95 3.36-.005-1.326-1.076-2.488-1.045-2.485 1.523.177 1.994-.875 1.994-.875zM46.875 69.216s.632-.925 1.533-1.064c0 0-.25-2.645-4.948-5.701 0 0 3.814 3.012 3.413 6.766h.002zm.117-2.867.199.296c.308.481.481.874.576 1.144a2.995 2.995 0 0 0-.372.199 6.913 6.913 0 0 0-.406-1.64h.002zM46.875 64.02c1.015 0 1.533-.998 1.533-.998-.357.709-.517 2.308-.517 2.308-.107-.668-1.015-1.309-1.015-1.309zM49.33 55.77l-.61.663-.836-.663h-.002.002-.002.002l.836-.661.61.661h.003-.003zM53.917 55.843v.002l-.624.661-.61-.661.61-.663.624.661zM24.817 23.007a3.57 3.57 0 0 0-3.564-3.566 3.57 3.57 0 0 0-3.564 3.566 3.566 3.566 0 0 0 3.564 3.564 3.57 3.57 0 0 0 3.564-3.564zm-.709 0a2.86 2.86 0 0 1-2.854 2.854 2.86 2.86 0 0 1-2.854-2.854 2.86 2.86 0 0 1 2.854-2.854 2.86 2.86 0 0 1 2.854 2.854z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.177 23.007a1.925 1.925 0 1 0-3.846.002 1.925 1.925 0 0 0 3.846-.002zm-.709 0a1.215 1.215 0 1 1-2.43 0 1.215 1.215 0 0 1 2.43 0zM56.169 26.573a3.57 3.57 0 0 0 3.564-3.564 3.57 3.57 0 0 0-3.564-3.566 3.57 3.57 0 0 0-3.564 3.566 3.566 3.566 0 0 0 3.564 3.564zm-2.854-3.564a2.86 2.86 0 0 1 2.854-2.854 2.86 2.86 0 0 1 2.854 2.854 2.86 2.86 0 0 1-2.854 2.854 2.86 2.86 0 0 1-2.854-2.854z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.245 23.007a1.925 1.925 0 1 0 3.85-.002 1.925 1.925 0 0 0-3.85.002zm.709 0a1.216 1.216 0 1 1 2.431.001 1.216 1.216 0 0 1-2.431-.001zM36.482 26.218c.117-.104-1.064-3.209-1.064-3.209s-8.187 2.041-11.313 5.886c0 0 3.659-1.873 7.548-1.873 1.375 0 2.779.233 4.059.867l.77-1.669v-.003zm-.729-.114-.394.855c-1.105-.43-2.349-.646-3.707-.646s-2.684.214-3.848.503a26.589 26.589 0 0 1 3.394-1.647 38.257 38.257 0 0 1 3.78-1.304l.773 2.242.002-.002z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.313 25.951s1.385-.782 3.277-1.02l.236 1.02s-1.586-.459-3.515 0h.002zM52.717 28.892c-3.126-3.843-11.313-5.886-11.313-5.886s-1.183 3.105-1.064 3.209l.77 1.669c1.283-.634 2.684-.867 4.059-.867 3.889 0 7.548 1.873 7.548 1.873v.002zm-3.695-2.079c-1.164-.289-2.49-.503-3.855-.503s-2.602.216-3.707.646l-.393-.855c.102-.381.43-1.319.773-2.24 1.312.377 4.506 1.385 7.181 2.952h.002z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.997 25.951.236-1.02c1.892.236 3.277 1.02 3.277 1.02-1.927-.459-3.515 0-3.515 0h.002z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caB",
    y: 43.274,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caU",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caU",
    x: 30.495,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caU",
    x: 26.081,
    y: 9.722,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caU",
    x: 26.081,
    y: -62.449,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.004 19.606a.43.43 0 1 1 0-.86.43.43 0 0 1 0 .86zM32.714 19.606a.43.43 0 1 0 0-.86.43.43 0 1 0 0 .86z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caU",
    x: 5.418,
    y: 9.722,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.004 91.949a.43.43 0 0 1 .43.43.43.43 0 0 1-.43.43.43.43 0 0 1-.43-.43.43.43 0 0 1 .43-.43zM32.714 91.966a.43.43 0 1 1 0 .86.43.43 0 1 1 0-.86z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caU",
    x: 5.418,
    y: -62.449,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.079 88.653a5.18 5.18 0 0 0 5.174 5.174 5.18 5.18 0 0 0 4.861-6.95 21.83 21.83 0 0 0 10.502 3.85l.16-.389.036.015 1.696-4.314 1.696 4.314.037-.015.175.413a21.854 21.854 0 0 0 10.822-3.899 5.15 5.15 0 0 0-.323 1.8 5.18 5.18 0 0 0 5.174 5.174 5.18 5.18 0 0 0 5.174-5.174 5.179 5.179 0 0 0-2.985-4.686c.486-1.642 2.388-8.519 2.422-15.703h-.024c-.126-4.837-2.356-9.433-5.196-12.516 2.791-3.029 4.992-7.521 5.186-12.268h.034c-.037-7.3-1.999-14.284-2.446-15.778a5.18 5.18 0 0 0-2.167-9.873 5.18 5.18 0 0 0-5.174 5.174 5.14 5.14 0 0 0 .323 1.8 21.83 21.83 0 0 0-10.822-3.899l-.175.413-.036-.015-1.696 4.314-1.696-4.314-.036.015-.16-.389a21.83 21.83 0 0 0-10.502 3.85 5.123 5.123 0 0 0 .313-1.776 5.18 5.18 0 0 0-5.174-5.174 5.18 5.18 0 0 0-5.174 5.174 5.175 5.175 0 0 0 3.051 4.715c-.398 1.334-1.929 6.792-2.339 12.989a.294.294 0 0 1-.005.051 14.18 14.18 0 0 0-.151 2.041h-.01c0 4.861 2.23 9.746 5.051 12.946-2.82 3.199-5.05 8.087-5.05 12.945h.01c0 .593.041 1.173.112 1.747.005.085.015.168.022.253.369 6.221 1.9 11.767 2.337 13.252a5.18 5.18 0 0 0-3.027 4.706l.002.005zM18.216 76.9a22.015 22.015 0 0 0 4.181 6.707 5.203 5.203 0 0 0-1.144-.129 5.24 5.24 0 0 0-1.482.216 63.387 63.387 0 0 1-1.555-6.795zm41.664-6.685c-.773 6.863-6.608 12.217-13.674 12.217a13.69 13.69 0 0 1-6.887-1.854 15.21 15.21 0 0 0 .748-.554 12.51 12.51 0 0 0 5.978 1.513c1.965 0 3.826-.447 5.49-1.244a5.77 5.77 0 0 0 2.055-1.237c3.156-2.325 5.206-6.061 5.206-10.271 0-1.108-.204-3.012-.641-4.139l-.09.272a4.224 4.224 0 0 0-4.001-2.888c-.058 0-.119 0-.177.005v.014a3.13 3.13 0 0 0-3.032 3.122 3.08 3.08 0 0 0 2.823 3.112c.138.024.282.041.428.041a2.43 2.43 0 0 0 2.427-2.427 2.43 2.43 0 0 0-2.427-2.427 2.43 2.43 0 0 0-2.427 2.427 2.24 2.24 0 0 1-.114-.724 2.42 2.42 0 0 1 2.417-2.417v-.01c.027 0 .053-.005.083-.005 1.934 0 3.508 1.574 3.508 3.508s-1.45 3.377-3.277 3.496v-.007a4.84 4.84 0 0 1-5.135-4.514 4.813 4.813 0 0 1 1.3-3.612l.005.01 4.642-5.415-.015-.012.017-.019c2.689 2.818 4.715 7.217 4.854 12.005h-.049l.012.683c0 .457-.017.909-.044 1.358l-.002-.007zm.032-26.729h.041c-.18 4.776-2.23 9.151-4.931 11.935l-4.475-5.218-.005.01a4.81 4.81 0 0 1-1.3-3.612 4.84 4.84 0 0 1 5.136-4.514v-.007c1.827.119 3.279 1.64 3.279 3.496s-1.574 3.508-3.508 3.508a.819.819 0 0 1-.083-.005v-.01a2.42 2.42 0 0 1-2.417-2.417c0-.255.041-.503.114-.736a2.431 2.431 0 0 0 2.427 2.439 2.43 2.43 0 0 0 2.427-2.427 2.43 2.43 0 0 0-2.427-2.427c-.146 0-.289.014-.43.041a3.13 3.13 0 0 0-2.823 3.112c0 1.623 1.351 3.071 3.032 3.122v.014l.177.005a4.222 4.222 0 0 0 4.059-3.078c.401-1.139.588-2.93.588-3.991a12.77 12.77 0 0 0-12.754-12.754c-2.162 0-4.198.549-5.978 1.513a13.81 13.81 0 0 0-.748-.554 13.68 13.68 0 0 1 6.887-1.854c6.999 0 12.79 5.252 13.65 12.022a21.042 21.042 0 0 1 .059 2.396l.002-.01zM38.656 30.491a14.884 14.884 0 0 0-1.79-.933l1.642-2.881 1.703 2.988a14.4 14.4 0 0 0-1.555.826zM19.035 42.705c0-3.279 1.319-6.253 3.45-8.427a5.732 5.732 0 0 0-.678 2.709c0 1.747.828 3.36 2.082 4.441a5.08 5.08 0 0 0-.721-.058v-.007a4.37 4.37 0 0 0-.177-.005 4.223 4.223 0 0 0-3.889 2.587 12.38 12.38 0 0 1-.066-1.239zm4.047 27.749v-.007a5.87 5.87 0 0 0 .721-.058c-1.251 1.081-2.079 2.694-2.079 4.441a5.74 5.74 0 0 0 .335 1.936 11.996 11.996 0 0 1-2.995-8.789 4.223 4.223 0 0 0 3.843 2.483c.058 0 .119 0 .177-.005h-.002zm7.638 3.058c0-2.371-1.832-4.297-4.084-4.297-.058 0-.117.005-.175.007a5.536 5.536 0 0 0 2.06-3.962 5.503 5.503 0 0 0-.542-2.76c.211-.513.43-.969.651-1.373a2.37 2.37 0 0 0 4.725-.27 2.366 2.366 0 0 0-2.359-2.368c.726-.42 1.239-.411 1.249-.408l.007-.187a6.84 6.84 0 0 0 4.188 4.302 6.837 6.837 0 0 0-4.706 6.496v.034a14.41 14.41 0 0 0 .736 4.484c-.046.029-.09.061-.136.09a5.02 5.02 0 0 1 .236 1.523 5.07 5.07 0 0 1-5.065 5.065 5.04 5.04 0 0 1-1.841-.347 11.99 11.99 0 0 1-1.414-.841 5.058 5.058 0 0 1-1.81-3.877c0-1.963 1.205-3.746 2.842-4.586v-.01a3.148 3.148 0 0 1 1.358-.308c1.861 0 3.374 1.611 3.374 3.588-.007 1.428-1.025 2.599-2.327 2.757.357-.308.583-.763.583-1.27 0-.928-.756-1.683-1.681-1.683s-1.681.755-1.681 1.683a1.68 1.68 0 0 0 .413 1.1l-.005.007c.022.022.046.041.07.063.08.083.17.158.267.224.498.372 1.11.593 1.776.593.027 0 .051 0 .075-.005v.014c1.781-.063 3.214-1.598 3.221-3.484l-.007.005zM25.611 75a.973.973 0 0 1 1.944 0 .974.974 0 0 1-.972.972.98.98 0 0 1-.539-.163 1.348 1.348 0 0 1-.158-.134.965.965 0 0 1-.274-.675zm17.323-6.304v.022c.316 5.296-3.241 8.553-4.283 9.389-1.071-.831-4.766-4.091-4.45-9.389v-.022c0-2.361 1.958-4.28 4.365-4.28a4.4 4.4 0 0 1 3.085 1.254 4.223 4.223 0 0 1 1.263 3.007h.017l.002.019zm-4.917 9.938c-.243.172-.491.335-.746.488a13.735 13.735 0 0 1-4.827-10.409 6.134 6.134 0 0 1 6.127-6.107c.058.003.119 0 .177 0a6.14 6.14 0 0 1 6.127 6.095c-.01 4.2-1.912 7.961-4.892 10.482-.291-.17-.573-.352-.85-.547l.007-.005.083-.068c1.263-1.052 4.74-4.458 4.426-9.863a4.935 4.935 0 0 0-1.489-3.527 5.1 5.1 0 0 0-3.603-1.479c-2.798 0-5.075 2.237-5.075 4.99h.017c-.049.862 0 1.659.119 2.407v.066c.039.221.09.442.143.658a11.21 11.21 0 0 0 .654 1.975l.029.068c.027.063.056.124.085.187a12.823 12.823 0 0 0 3.496 4.596l-.007-.007zm13.266.991a5.076 5.076 0 0 1-1.623.267 5.07 5.07 0 0 1-5.065-5.065 5.02 5.02 0 0 1 .236-1.523l-.012-.007a14.43 14.43 0 0 0 .763-4.567v-.032a6.836 6.836 0 0 0-4.696-6.493A6.86 6.86 0 0 0 44 59.924a2.373 2.373 0 0 0-.194.94 2.37 2.37 0 1 0 4.742 0 2.37 2.37 0 0 0-2.371-2.371 2.36 2.36 0 0 0-1.701.721 6.773 6.773 0 0 0 .896-2.777c2.235.369 4.246 3.656 4.735 4.514a5.534 5.534 0 0 0 .393 8.269c-2.242.012-4.062 1.934-4.064 4.297.007 1.875 1.424 3.403 3.192 3.481a1.683 1.683 0 0 0 2.143-1.615c0-.926-.756-1.683-1.681-1.683s-1.681.755-1.681 1.683c0 .197.036.386.1.564-.804-.474-1.353-1.382-1.358-2.429 0-1.977 1.514-3.588 3.374-3.588.486 0 .945.112 1.36.308v.01c1.635.84 2.84 2.624 2.84 4.587a5.06 5.06 0 0 1-1.594 3.685 12.02 12.02 0 0 1-1.846 1.113l-.002-.007zm6.807-10.844c0 3.02-1.12 5.779-2.961 7.895a5.75 5.75 0 0 0 .306-1.849c0-1.732-.814-3.331-2.048-4.412.165.017.333.029.5.032v.007l.177.005a4.225 4.225 0 0 0 3.972-2.801c.034.369.053.743.053 1.122zm-8.971 6.598a.973.973 0 0 1 1.944 0c0 .535-.437.972-.972.972s-.972-.437-.972-.972zm1.074-24.514c-.493.865-2.539 4.203-4.795 4.523a6.81 6.81 0 0 0-.668-2.626 2.36 2.36 0 0 0 1.53.561 2.37 2.37 0 1 0 0-4.742 2.37 2.37 0 0 0-2.371 2.371 2.31 2.31 0 0 0 .075.58 6.85 6.85 0 0 0-3.078-2.235 6.836 6.836 0 0 0 4.696-6.493v-.034a14.38 14.38 0 0 0-.707-4.399 5.022 5.022 0 0 1-.197-1.385 5.07 5.07 0 0 1 5.065-5.065 5.07 5.07 0 0 1 5.065 5.065c0 1.963-1.205 3.746-2.842 4.587v.01a3.148 3.148 0 0 1-1.358.308c-1.861 0-3.374-1.611-3.374-3.588.005-1.047.554-1.956 1.358-2.429-.063.177-.1.364-.1.564 0 .928.755 1.681 1.681 1.681s1.681-.755 1.681-1.681-.756-1.681-1.681-1.681a1.71 1.71 0 0 0-.462.066c-1.769.08-3.185 1.606-3.192 3.481 0 2.364 1.822 4.285 4.064 4.297a5.535 5.535 0 0 0-.393 8.269l.003-.005zm3.782-9.506v.007a4.9 4.9 0 0 0-.5.032c1.234-1.081 2.048-2.682 2.048-4.412a5.74 5.74 0 0 0-.449-2.233 11.994 11.994 0 0 1 3.019 7.966 12.2 12.2 0 0 1-.061 1.2 4.222 4.222 0 0 0-3.879-2.563c-.058 0-.119 0-.177.005v-.002zm-13.329-9.404a11.95 11.95 0 0 1 5.403-1.283 12.03 12.03 0 0 1 3.569.539 5.784 5.784 0 0 0-5.602 5.077 14.57 14.57 0 0 0-3.369-4.334zM29.413 50.95c0-.916.746-1.662 1.662-1.662s1.662.746 1.662 1.662-.746 1.662-1.662 1.662-1.662-.746-1.662-1.662zm3.173 1.827a6.71 6.71 0 0 0-.369.943c-.189-.022-.595-.107-1.108-.401a2.352 2.352 0 0 0 1.477-.542zm-6.486.051a1.38 1.38 0 0 1 .199-.017 1.168 1.168 0 0 1 1.147 1.361 1.156 1.156 0 0 1-.945.945 1.17 1.17 0 0 1-1.086-.394 1.157 1.157 0 0 1 .685-1.895zm-.403 6.518c.189.066.391.102.602.102.284 0 .552-.066.792-.177l-.177.262c-.18.265-.33.508-.452.707l-.768-.894h.003zm24.115-1.705c.078-.479.466-.867.945-.945a1.38 1.38 0 0 1 .199-.017 1.168 1.168 0 0 1 1.147 1.361 1.156 1.156 0 0 1-.945.945 1.17 1.17 0 0 1-1.086-.393 1.166 1.166 0 0 1-.26-.95zm1.341 2.06-.469.547a13.78 13.78 0 0 0-.418-.668c.216.085.449.134.69.134a1.78 1.78 0 0 0 .197-.012zm-18.525-3.95c.007-3.311 2.658-6.012 5.949-6.107a6.135 6.135 0 0 1 6.127 6.107 6.135 6.135 0 0 1-6.127 6.107 6.13 6.13 0 0 1-5.949-6.107zm-7.487 1.827a1.16 1.16 0 1 1 2.322 0 1.16 1.16 0 1 1-2.322 0zm3.022-3.775c.731.836 1.628 1.635 2.611 2.043-.993.41-1.897 1.222-2.631 2.065a1.88 1.88 0 0 0 .032-.333 1.87 1.87 0 0 0-1.37-1.8 1.88 1.88 0 0 0 1.343-1.489c.027-.163.029-.325.015-.486zm22.021-18.339a.973.973 0 0 1 0 1.944c-.535 0-.972-.437-.972-.972s.437-.972.972-.972zm-3.916 13.83c.916 0 1.662.746 1.662 1.662s-.746 1.662-1.662 1.662-1.662-.746-1.662-1.662.746-1.662 1.662-1.662zm5.663 5.432c-.221.26-.544.41-.887.41a1.1 1.1 0 0 1-.199-.017 1.157 1.157 0 0 1-.945-.945 1.162 1.162 0 1 1 2.031.552zm-1.241-3.282.581.678a1.89 1.89 0 0 0-1.164.243 15.99 15.99 0 0 0 .583-.918v-.002zm2.225 2.594 1.55 1.807-1.635 1.907a1.851 1.851 0 0 0-.442-1.12 1.89 1.89 0 0 0-1.742-.634 1.872 1.872 0 0 0-1.53 1.53 1.86 1.86 0 0 0-.015.479c-.751-.877-1.683-1.735-2.713-2.162 1.093-.452 2.075-1.385 2.845-2.318a1.902 1.902 0 0 0-.032.76 1.875 1.875 0 0 0 1.53 1.531 1.95 1.95 0 0 0 .313.027 1.86 1.86 0 0 0 1.426-.661c.275-.323.428-.729.442-1.149l.002.002zm-6.729 5.165c.916 0 1.662.746 1.662 1.662s-.746 1.662-1.662 1.662-1.662-.746-1.662-1.662.746-1.662 1.662-1.662zm2.536 21.324c-.858.194-1.749.301-2.667.301a11.98 11.98 0 0 1-5.403-1.283 14.63 14.63 0 0 0 3.272-4.142 5.79 5.79 0 0 0 4.798 5.123zm-12.1-1.035a11.974 11.974 0 0 1-8.219 1.045 5.783 5.783 0 0 0 4.873-5.393 14.473 14.473 0 0 0 3.345 4.348zm-5.626-20.289c.916 0 1.662.746 1.662 1.662s-.746 1.662-1.662 1.662-1.662-.746-1.662-1.662.746-1.662 1.662-1.662zm-4.113 1.756a15.25 15.25 0 0 1 .624-1.023c.938-1.392 2.641-3.484 4.443-3.532a7.16 7.16 0 0 0 .163.979c-.624.053-2.833.522-4.569 4.36a5.68 5.68 0 0 0-.661-.785zm-4.188-5.114 1.744-2.033a1.88 1.88 0 0 0 .435 1.375c.245.289.571.493.93.59a1.874 1.874 0 0 0-1.375 1.803 2.03 2.03 0 0 0 .029.325l-1.766-2.06h.002zm3.163-3.69.61-.712a18.33 18.33 0 0 0 .493.785 1.9 1.9 0 0 0-.977-.097c-.044.007-.085.017-.129.027l.002-.002zm1.098-1.29a5.64 5.64 0 0 0 .671-.792c1.618 3.576 3.646 4.227 4.419 4.343a7 7 0 0 0-.121.991c-2.322-.165-4.463-3.654-4.968-4.54v-.002zm1.657-4.314a5.54 5.54 0 0 0-2.06-3.962c.058.002.117.007.175.007 2.252 0 4.084-1.929 4.084-4.297-.007-1.885-1.438-3.42-3.221-3.484v.015c-.024 0-.051-.005-.075-.005-.666 0-1.28.223-1.776.593a1.695 1.695 0 0 0-.267.224c-.022.022-.046.041-.07.063l.005.007a1.67 1.67 0 0 0-.413 1.1 1.683 1.683 0 0 0 3.364 0c0-.508-.226-.962-.583-1.27 1.305.158 2.322 1.329 2.327 2.757 0 1.977-1.513 3.588-3.374 3.588a3.17 3.17 0 0 1-1.36-.308v-.01c-1.635-.84-2.84-2.624-2.84-4.587a5.07 5.07 0 0 1 5.065-5.065 5.07 5.07 0 0 1 5.065 5.065c0 .403-.049.792-.136 1.169-.498 1.45-.773 3-.78 4.616v.034a6.84 6.84 0 0 0 4.706 6.496 6.845 6.845 0 0 0-3.068 2.215 2.39 2.39 0 0 0 .07-.564 2.37 2.37 0 0 0-4.725-.272 12.574 12.574 0 0 1-.651-1.368 5.501 5.501 0 0 0 .542-2.76l-.002.002zm-.964-9.736a.973.973 0 0 1-1.944 0 .966.966 0 0 1 .435-.809.98.98 0 0 1 .539-.163c.537 0 .972.437.972.972h-.002zm-.172-5.602a12 12 0 0 1 3.612-.554 11.95 11.95 0 0 1 5.531 1.351 14.57 14.57 0 0 0-3.299 4.258c-.355-2.847-2.786-5.058-5.728-5.058-.039 0-.078 0-.117.002zm9.802 1.164a12.74 12.74 0 0 1 .746.488 12.8 12.8 0 0 0-3.496 4.596c-.029.061-.056.124-.085.187l-.029.068a11.05 11.05 0 0 0-.654 1.975 15.14 15.14 0 0 0-.146.658v.066a11.267 11.267 0 0 0-.117 2.39c0 2.752 2.276 4.99 5.075 4.99s5.075-2.237 5.075-4.99c.311-5.405-3.163-8.811-4.426-9.863-.027-.024-.056-.046-.083-.068l-.007-.005a11.53 11.53 0 0 1 .85-.547 13.797 13.797 0 0 1 4.205 6.224 7.33 7.33 0 0 0 .109.35c.372 1.239.576 2.551.578 3.909a6.134 6.134 0 0 1-6.127 6.095l-.177-.002a6.13 6.13 0 0 1-6.127-6.105c.005-1.343.206-2.641.571-3.87.075-.175.131-.364.18-.556a13.81 13.81 0 0 1 4.079-5.983l.005-.007zm5.665 10.426c0 2.361-1.958 4.28-4.365 4.28s-4.365-1.919-4.365-4.28v-.022c-.316-5.298 3.379-8.561 4.45-9.389 1.042.836 4.599 4.096 4.285 9.389v.022h-.005zM37.84 31.917c.267-.207.542-.401.824-.588.258.17.508.345.751.53-.287.177-.566.367-.836.569-.241-.18-.486-.35-.739-.513v.002zm16.009 12.324a2.34 2.34 0 0 1 .226-.012v-.019c.041-.002.083-.007.126-.007a1.72 1.72 0 0 1 1.718 1.718 1.72 1.72 0 0 1-1.718 1.718 1.72 1.72 0 0 1-1.718-1.718 1.72 1.72 0 0 1 1.368-1.681l-.002.002zm-.085 23.328a1.72 1.72 0 0 1-1.368-1.681 1.72 1.72 0 0 1 1.718-1.718 1.72 1.72 0 0 1 1.718 1.718 1.72 1.72 0 0 1-1.718 1.718c-.041 0-.083-.002-.126-.007v-.02a2.34 2.34 0 0 1-.226-.012l.002.002zm-15.1 12.596a13.122 13.122 0 0 1-.824-.588 11.76 11.76 0 0 0 .739-.513c.27.199.549.389.836.569-.245.185-.495.362-.751.529v.002zm-.663.408a13.68 13.68 0 0 1-6.887 1.853c-6.979 0-12.756-5.223-13.643-11.964a44.671 44.671 0 0 1-.068-2.206v-.085h-.056c.124-4.686 1.9-8.889 4.662-11.816l4.506 5.255.005-.01a4.81 4.81 0 0 1 1.3 3.612 4.84 4.84 0 0 1-5.135 4.514v.007c-1.827-.119-3.28-1.64-3.28-3.496s1.574-3.508 3.508-3.508c.027 0 .053.003.083.005v.01a2.42 2.42 0 0 1 2.417 2.417 2.38 2.38 0 0 1-.024.325 2.43 2.43 0 0 0-2.4-2.089 2.43 2.43 0 0 0-2.427 2.427l-.002.01a2.45 2.45 0 0 0 2.439 2.449v.005a3.13 3.13 0 0 0 3.127-3.126 3.106 3.106 0 0 0-3.032-3.122v-.015c-.058-.002-.119-.005-.177-.005a4.221 4.221 0 0 0-3.923 2.675l-.015-.041c-.437 1.127-.641 3.029-.641 4.139 0 4.324 2.165 8.148 5.463 10.456a5.847 5.847 0 0 0 1.594.95 12.673 12.673 0 0 0 5.697 1.348c2.213 0 4.29-.573 6.098-1.579a14.25 14.25 0 0 0 .816.607L38 80.573zM21.268 65.827a1.72 1.72 0 0 1 1.717-1.718 1.72 1.72 0 0 1 1.718 1.718 1.72 1.72 0 0 1-1.718 1.718 1.72 1.72 0 0 1-1.717-1.718zm.86-10.567c-2.796-2.898-4.613-7.089-4.774-11.777h.049a45.89 45.89 0 0 1 .095-2.665c.979-6.639 6.71-11.75 13.614-11.75 2.507 0 4.858.678 6.887 1.854-.279.192-.551.396-.816.607a12.51 12.51 0 0 0-6.097-1.579 12.77 12.77 0 0 0-12.754 12.754c0 1.108.204 3.012.641 4.139a4.224 4.224 0 0 0 4.02 2.947c.058 0 .119 0 .177-.005v-.015a3.13 3.13 0 0 0 3.032-3.122c0-1.691-1.402-3.126-3.126-3.126v.005a2.453 2.453 0 0 0-2.439 2.449h.002a2.43 2.43 0 0 0 2.427 2.437 2.428 2.428 0 0 0 2.4-2.089 2.38 2.38 0 0 1 .024.325 2.42 2.42 0 0 1-2.417 2.417v.01c-.027 0-.053.005-.083.005-1.934 0-3.508-1.574-3.508-3.508s1.45-3.377 3.277-3.496v.007a4.84 4.84 0 0 1 5.135 4.514 4.81 4.81 0 0 1-1.3 3.612l-.005-.01-4.329 5.05-.058-.075-.083.088.007-.003zm2.66-9.28a1.72 1.72 0 0 1-1.718 1.718 1.72 1.72 0 0 1-1.718-1.718 1.72 1.72 0 0 1 1.718-1.717 1.72 1.72 0 0 1 1.718 1.717zM19.8 27.967a5.16 5.16 0 0 0 2.602.082 21.997 21.997 0 0 0-4.152 6.639 62.977 62.977 0 0 1 1.552-6.719l-.003-.003zm4.861-2.079a21.82 21.82 0 0 0-.974.86c-.7.457-1.533.722-2.429.722a4.47 4.47 0 0 1-4.465-4.465 4.47 4.47 0 0 1 4.465-4.465 4.47 4.47 0 0 1 4.465 4.465 4.445 4.445 0 0 1-1.059 2.884h-.002zm13.312.299-1.766 3.1a14.43 14.43 0 0 0-5.097-.928c-5.225 0-9.812 2.784-12.358 6.945a21.34 21.34 0 0 1 5.296-7.949 5.202 5.202 0 0 0 1.161-1.023 21.182 21.182 0 0 1 10.985-4.657l1.773 4.511h.005zm14.231.228c.294.335.632.634 1.003.884a21.324 21.324 0 0 1 5.354 7.995c-2.546-4.157-7.13-6.936-12.35-6.936a14.37 14.37 0 0 0-5.68 1.164l.318-.18-1.795-3.153 1.786-4.543c4.292.44 8.211 2.16 11.364 4.771v-.003zm3.887 1.054a4.43 4.43 0 0 1-2.519-.782 21.896 21.896 0 0 0-.811-.714 4.44 4.44 0 0 1-1.132-2.966 4.47 4.47 0 0 1 4.465-4.465 4.47 4.47 0 0 1 4.465 4.465 4.47 4.47 0 0 1-4.465 4.465l-.003-.002zm1.501.486a63.361 63.361 0 0 1 1.616 7.076 21.946 21.946 0 0 0-4.295-6.991 5.138 5.138 0 0 0 2.679-.087v.002zm.024 55.749a5.184 5.184 0 0 0-2.704-.092 22.03 22.03 0 0 0 4.322-7.059 63.247 63.247 0 0 1-1.618 7.152zm-4.856 1.977a20.47 20.47 0 0 0 .811-.714 4.437 4.437 0 0 1 2.522-.782 4.47 4.47 0 0 1 4.465 4.465 4.47 4.47 0 0 1-4.465 4.465 4.47 4.47 0 0 1-4.465-4.465c0-1.139.43-2.179 1.132-2.969zm-13.706-.214 1.795-3.153-.617-.352-1.718 3.017-1.715-3.01c.646-.277 1.268-.6 1.863-.964a14.38 14.38 0 0 0 7.55 2.13c5.332 0 9.996-2.901 12.508-7.205a21.33 21.33 0 0 1-5.512 8.425c-.372.25-.709.549-1.003.884a21.194 21.194 0 0 1-11.364 4.771l-1.785-4.543h-.002zm-13.837-.146a5.24 5.24 0 0 0-1.161-1.023 21.3 21.3 0 0 1-5.454-8.379c2.509 4.31 7.179 7.217 12.516 7.217a14.4 14.4 0 0 0 5.612-1.132l-.544.311 1.795 3.153-1.773 4.511a21.173 21.173 0 0 1-10.985-4.657l-.005-.002zm-8.422 3.328a4.47 4.47 0 0 1 4.465-4.465c.896 0 1.73.265 2.429.721a21.76 21.76 0 0 0 .974.86 4.44 4.44 0 0 1 1.059 2.884 4.47 4.47 0 0 1-4.465 4.465 4.47 4.47 0 0 1-4.465-4.465h.002z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caV",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caW",
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.008 57.592a1.925 1.925 0 1 0-.002-3.85 1.925 1.925 0 0 0 .002 3.85zm-1.215-1.924a1.215 1.215 0 1 1 2.43 0 1.215 1.215 0 0 1-2.43 0z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caW",
    x: 7.332,
    y: 3.211,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caW",
    x: 27.995,
    y: 3.211,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caX",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caX",
    x: -12.291,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caY",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caY",
    x: 20.661,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caZ",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caZ",
    x: -12.29,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.926 55.668a1.925 1.925 0 1 0-3.85.002 1.925 1.925 0 0 0 3.85-.002zm-.709 0a1.216 1.216 0 1 1-2.431-.001 1.216 1.216 0 0 1 2.431.001z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caV",
    x: 34.918,
    className: "caB"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#caW",
    x: 34.916,
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.418 88.653 1.064-3.209-.77-1.669c-1.283.634-2.684.867-4.059.867-3.889 0-7.548-1.873-7.548-1.873 3.127 3.843 11.313 5.886 11.313 5.886v-.002zM27.8 84.846c1.164.289 2.49.503 3.855.503s2.602-.216 3.707-.646l.394.855c-.102.381-.43 1.319-.773 2.24-1.312-.377-4.506-1.385-7.181-2.951H27.8z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.825 85.711-.236 1.02c-1.892-.236-3.277-1.02-3.277-1.02 1.926.459 3.515 0 3.515 0h-.003zM41.11 83.775l-.77 1.669c-.117.105 1.064 3.209 1.064 3.209s8.187-2.041 11.313-5.886c0 0-3.659 1.873-7.548 1.873-1.375 0-2.779-.233-4.059-.867v.002zm-.041 1.783.394-.855c1.105.43 2.349.646 3.707.646s2.689-.216 3.855-.503c-2.675 1.567-5.869 2.575-7.181 2.952l-.773-2.24h-.002z",
    className: "caB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.509 85.711s-1.385.782-3.277 1.02l-.236-1.02s1.586.459 3.515 0h-.002zM34.826 32.209s-1.125.824-1.217 1.768c0 0-.607-1.535-1.705-2.128 0 0 1.504-.287 2.922.36zM45.429 31.849c-1.098.59-1.705 2.128-1.705 2.128-.092-.945-1.217-1.768-1.217-1.768 1.419-.646 2.922-.36 2.922-.36zM33.609 77.646c.092.945 1.217 1.769 1.217 1.769-1.419.646-2.922.359-2.922.359 1.098-.59 1.705-2.128 1.705-2.128zM42.507 79.414s1.125-.823 1.217-1.769c0 0 .607 1.535 1.705 2.128 0 0-1.504.287-2.922-.359zM16.691 49.92l1.555 2.947h-1.555V49.92zM16.691 61.561v-2.947h1.555l-1.555 2.947zM60.571 49.92v2.947h-1.555l1.555-2.947zM60.571 61.561l-1.555-2.947h1.555v2.947zM38.545 22.416l-.027-.175-.027.175-.675-2.723-2.167-1.001h2.85v-.002h2.891l-2.167 1.003-.678 2.723zM38.491 89.496l.027.175.027-.175.678 2.723 2.167 1.003h-5.741l2.167-1.003.675-2.723z",
    className: "caB"
  }))), _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "caB",
    d: "M38.569 40.07a.576.576 0 1 1 0-1.152.576.576 0 0 1 0 1.152z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caC",
    d: "M19.307 49.544a.255.255 0 1 0 0-.51.255.255 0 0 0 0 .51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caD",
    d: "M18.775 47.889a.255.255 0 1 1 0 .51.255.255 0 0 1 0-.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caE",
    d: "M38.569 73.091a.413.413 0 1 1 0 .826.413.413 0 0 1 0-.826z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caF",
    d: "M29.015 38.843a.43.43 0 0 0 .43-.43.43.43 0 0 0-.86 0 .43.43 0 0 0 .43.43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caG",
    d: "M26.199 39.912a.54.54 0 0 1 .539.539.54.54 0 0 1-.539.539.54.54 0 0 1-.539-.539.54.54 0 0 1 .539-.539z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caH",
    d: "M24.637 38.957a.434.434 0 1 1 0 .87.434.434 0 1 1 0-.87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caI",
    d: "M23.923 36.436a.432.432 0 1 0 0-.864.432.432 0 0 0 0 .864z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caJ",
    d: "M26.372 33.977a.433.433 0 1 1 .002-.866.433.433 0 0 1-.002.866z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caK",
    d: "M31.123 37.174a.433.433 0 1 1 .866.002.433.433 0 0 1-.866-.002z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caL",
    d: "M25.363 43.84a.177.177 0 1 0 0-.354.177.177 0 1 0 0 .354z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caM",
    d: "M22.752 43.092a.143.143 0 1 0 0-.286.143.143 0 0 0 0 .286z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caN",
    d: "M18.151 45.842a.143.143 0 1 1 0 .286.143.143 0 0 1 0-.286z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caO",
    d: "M46.258 50.037a.917.917 0 0 0 0 1.832.917.917 0 0 0 0-1.832zm0 .532a.385.385 0 1 1-.001.77.385.385 0 0 1 .001-.77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caP",
    d: "M50.429 47.445a.35.35 0 0 1 .35.35.35.35 0 0 1-.35.35.35.35 0 0 1-.35-.35.35.35 0 0 1 .35-.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caQ",
    d: "M50.956 49.289a.35.35 0 0 1-.35-.35.35.35 0 0 1 .35-.35.35.35 0 0 1 .35.35.35.35 0 0 1-.35.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caR",
    d: "M51.129 40.991a.54.54 0 0 1-.539-.539.54.54 0 0 1 .539-.539.54.54 0 0 1 .539.539.54.54 0 0 1-.539.539z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caS",
    d: "M53.584 37.257a.433.433 0 1 1-.002.866.433.433 0 0 1 .002-.866z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caT",
    d: "M59.177 46.129a.143.143 0 1 1 0-.286.143.143 0 0 1 0 .286z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caU",
    d: "M23.167 82.572a.43.43 0 1 0 0-.86.43.43 0 0 0 0 .86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caV",
    d: "M17.687 88.653a3.57 3.57 0 0 0 3.564 3.564 3.57 3.57 0 0 0 3.564-3.564 3.57 3.57 0 0 0-3.564-3.566 3.57 3.57 0 0 0-3.564 3.566zm.709 0a2.86 2.86 0 0 1 2.854-2.854 2.86 2.86 0 0 1 2.854 2.854 2.86 2.86 0 0 1-2.854 2.854 2.86 2.86 0 0 1-2.854-2.854z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caW",
    d: "M19.329 88.653a1.925 1.925 0 1 0 3.85-.002 1.925 1.925 0 0 0-3.85.002zm.709 0a1.215 1.215 0 1 1 2.43 0 1.215 1.215 0 0 1-2.43 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caX",
    d: "M43.54 92.379c0 .809.658 1.465 1.465 1.465a1.47 1.47 0 0 0 1.465-1.465 1.47 1.47 0 0 0-1.465-1.465 1.47 1.47 0 0 0-1.465 1.465zm.532 0a.933.933 0 1 1 1.867 0 .933.933 0 0 1-1.867 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caY",
    d: "M30.511 19.693a1.925 1.925 0 1 0-3.85.002 1.925 1.925 0 0 0 3.85-.002zm-.709 0a1.215 1.215 0 1 1-2.43 0 1.215 1.215 0 0 1 2.43 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caZ",
    d: "M46.469 19.176c0-.809-.658-1.465-1.465-1.465a1.47 1.47 0 0 0-1.465 1.465 1.47 1.47 0 0 0 1.465 1.465 1.47 1.47 0 0 0 1.465-1.465zm-.532 0a.933.933 0 1 1-1.867 0 .933.933 0 0 1 1.867 0z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "caA",
    x: 0.214,
    y: 0.879,
    width: 77.184,
    height: 109.829,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "A"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "B"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.393
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "B",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "A"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    width: 46,
    height: 57,
    id: "card_simple_omaha_back_bf",
    x: 432,
    y: 57,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-121.438%",
    x2: "50%",
    y2: "100%",
    id: "ccc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cbd9e4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2b3e4b",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-17.1%",
    y: "-11.2%",
    width: "134.2%",
    height: "126.5%",
    id: "cca"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.39966674 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "ccb",
    width: 38,
    height: 49,
    rx: 4
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#cca)",
    href: "#ccb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#ccc)",
    href: "#ccb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.24 19.333h-6.834v3.295h-3.652l7.052 7.906 7.051-7.906h-3.616v-3.295zm-19.454 13.04h3.652v3.294h6.799v-3.295h3.652l-7.052-7.906-7.051 7.906z",
    fill: "#fff",
    fillRule: "nonzero",
    opacity: 0.251
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpritecssD6F47756);
export default __webpack_public_path__ + "static/media/sprite.css-d6f47756.4b9cf71be0058679322f624aa0e022d7.svg";
export { ForwardRef as ReactComponent };